/**
 * Created by chenguangjun on 2016/9/29.
 */
import Vue from 'vue';
import Vuex from 'vuex';

import vueResource from 'vue-resource';

import CH from '../gadgets/cookieHandler';

Vue.use(Vuex);

Vue.use(vueResource);
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push(function (request, next) {
  // 跨域携带cookie
  request.credentials = true;
  next();
});
function _GET ({ dispatch, commit }, url = '', params = {}) {
  return Vue.http.get(url, {
    params
  }).then(res => {
    if (res.status === 200) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res);
    }
  }).catch(res => {
    return Promise.reject(res);
  });
}

function GET ({ dispatch, commit }, url = '', params = {}) {
  return _GET({ dispatch, commit }, url, params).then(res => {
    if (res.status === 200) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res);
    }
  }).catch(res => {
    return Promise.reject(res);
  });
}

function _POST ({ dispatch, commit }, url = '', params = {}) {
  return Vue.http.post(url, params).then((res) => {
    const json = res.json();

    if (res.status === 200 || (res.status === 302 && json.status !== 403)) {    // HTML Status
      return json;  //  返回数据
    } else if (res.status === 302 && json.status === 403) {
      commit('HAS_LOGGED_OUT');
    } else {
      return Promise.reject(res);
    }
  }).catch((res) => {
    if (res.status === 302 || res.status === 0) {
      commit('HAS_LOGGED_OUT');
    }
    return Promise.reject(res);
  });
}

function POST ({ dispatch, commit }, url = '', params = {}) {
  // console.log(document.cookie);

  return _POST({ dispatch, commit }, url, params).then((res) => {
    if (res.status === 200) {                             // Protocal Status
      return res.data;
    } else if (res.status === 403) {
      commit('HAS_LOGGED_OUT');
    } else {
      return Promise.reject(res);
    }
  }).catch((res) => {
    return res.data ? Promise.reject(res.data) : Promise.reject(res);
  });
}

function _JSONP ({ dispatch, commit }, url = '', params = {}) {
  return Vue.http.jsonp(url, { params }).then((res) => {
    if (res.status === 200) {
      return res.json();  //  返回
    } else {
      return Promise.reject(res);
    }
  }).catch((res) => {
    return Promise.reject(res);
  });
}

function BAIDU_JSONP ({ dispatch, commit }, url = '', params = {}) {
  return _JSONP({ dispatch, commit }, url, params).then((res) => {
    if (res.status === 0) {
      return res.result;
    } else {
      return Promise.reject(res);
    }
  }).catch((res) => {
    return Promise.reject(res);
  });
}

const ak = 'Ee2XHDmKM480LmV9QjfNbK3BKGxbGWUF';    // Secure App Key for Baidu Map

export default new Vuex.Store({
  state: {
    downloadCenter: {
      processing: false,
      isNew: false,
      visible: false
    },
    loginStatus: false,
    systemInfo: {
      agreeProtocol: null,
      environment: null,
      community: {},
      login: {},
      defCommunityIds: '',
      communityList: [],
      role: {},
    },
    menuList: [],
    ifaceList: {},

    activeMenuIndex: 0,
    activeItemIndex: '0',

    unreadSysMsgCount: 0,
    unreadMsgInfoCount: 0,
    unreadSysNoticeCount: 0,

    deptSelectorShow: false,
    selectedDept: {
      id: null
    },
    areaSelectorShow: false,
    selectedArea: {
      id: null
    },
    roleSelectorShow: false,
    selectedRole: {
      id: null
    },

    adCategoryList: null,   // 广告分类列表
    addAdCategoryList: null,   // 新增广告--广告分类列表
    editAdCategoryList: null,   // 新增广告--广告分类列表

    sysResourceList: null,   // 系统资源列表

    repairProblemTypeList: null,     // 意见/保修类型列表

    venueServiceTypeList: null,     // 场地服务类型列表
    enabledVenueList: null,     // 处于启用状态的场地列表

    cityCommunityList: [],       // 城市及社区列表
    themeCommTagList: [],       // 虚拟社区类型

    cityCommunityList_match: [],      // 数据匹配城市及社交列表

    virtualCityCommunityList: [],   // 虚拟社区

    parkingConfList: null,     // 停车场列表
  },
  mutations: {
    UPDATE_DOWNLOAD_CENTER_PROCESSING (state, processing = false) {
      state.downloadCenter.processing = !!processing;
    },
    UPDATE_DOWNLOAD_CENTER_IS_NEW (state, isNew = false) {
      state.downloadCenter.isNew = !!isNew;
    },
    UPDATE_DOWNLOAD_CENTER_VISIBLE (state, visible = false) {
      state.downloadCenter.visible = !!visible;
    },
    IS_LOGIN (state) {
      state.loginStatus = true;
    },
    NOT_LOGIN (state) {
      state.loginStatus = false;
    },
    HAS_LOGGED_OUT (state) {
      state.loginStatus = null;
    },

    SET_SYSTEM_INFO (state, systemInfo) {
      state.systemInfo = systemInfo;
    },
    SET_MENU_LIST (state, menuList) {
      state.menuList = menuList;
    },
    SET_IFACE_LIST (state, { to, iface }) {
      let o = {};
      o[to] = iface;
      state.ifaceList = Object.assign(state.ifaceList, o);
    },

    SET_ACTIVE_MENU_INDEX (state, activeMenuIndex) {
      state.activeMenuIndex = activeMenuIndex;
    },
    SET_ACTIVE_ITEM_INDEX (state, activeItemIndex) {
      state.activeItemIndex = activeItemIndex;
    },

    SET_UNREAD_MSG_COUNT (state, count) {
      state.unreadSysMsgCount = count;
    },
    SET_UNREAD_NOTICE_COUNT (state, count) {
      state.unreadSysNoticeCount = count;
    },
    SET_UNREAD_MSG_INFO_COUNT (state, count) {
      state.unreadMsgInfoCount = count;
    },

    SHOW_AREA_SELECTOR (state) {
      state.areaSelectorShow = true;
    },
    HIDE_AREA_SELECTOR (state) {
      state.areaSelectorShow = false;
    },
    SELECT_AREA (state, area) {
      state.selectedArea = area;
    },
    CLEAR_AREA_SELECTOR (state) {
      state.areaSelectorShow = false;
      state.selectedArea = {
        id: null
      };
    },

    SHOW_DEPT_SELECTOR (state) {
      state.deptSelectorShow = true;
    },
    HIDE_DEPT_SELECTOR (state) {
      state.deptSelectorShow = false;
    },
    SELECT_DEPT (state, dept) {
      state.selectedDept = dept;
    },
    CLEAR_DEPT_SELECTOR (state) {
      state.deptSelectorShow = false;
      state.selectedDept = {
        id: null
      };
    },

    SHOW_ROLE_SELECTOR (state) {
      state.roleSelectorShow = true;
    },
    HIDE_ROLE_SELECTOR (state) {
      state.roleSelectorShow = false;
    },
    SELECT_ROLE (state, role) {
      state.selectedRole = role;
    },
    CLEAR_ROLE_SELECTOR (state) {
      state.roleSelectorShow = false;
      state.selectedRole = {
        id: null
      };
    },

    SET_AD_CATEGORY_LIST (state, list) {
      state.adCategoryList = list;
    },
    SET_ADD_AD_CATEGORY_LIST (state, list) {
      state.addAdCategoryList = list;
    },
    SET_EDIT_AD_CATEGORY_LIST (state, list) {
      state.editAdCategoryList = list;
    },

    SET_SYS_RESOURCE_LIST (state, list) {
      state.sysResourceList = list;
    },

    SET_REPAIR_PROBLEM_TYPE_LIST (state, repairProblemTypeList) {
      state.repairProblemTypeList = repairProblemTypeList;
    },

    SET_VENUE_SERVICE_TYPE_LIST (state, venueServiceTypeList) {
      state.venueServiceTypeList = venueServiceTypeList;
    },
    SET_ENABLED_VENUE_LIST (state, enabledVenueList) {
      state.enabledVenueList = enabledVenueList;
    },

    SET_CITY_COMMUNITY_LIST (state, list) {
      state.cityCommunityList = list;
    },
    SET_THEME_COMM_TAG_LIST (state, list) {
      state.themeCommTagList = list;
    },
    SET_CITY_COMMUNITY_LIST_MATCH (state, list) {
      state.cityCommunityList_match = list;
    },

    SET_VIRTUAL_COMMUNITY_LIST (state, list) {
      state.virtualCityCommunityList = list;
    },

    SET_PARKING_CONF_LIST (state, parkingConfList) {
      state.parkingConfList = parkingConfList;
    },
  },

  actions: {
    // 监听下载中心进程
    WATCH_DOWN_PROGRESS ({ dispatch, commit, state }) {
      return new Promise(async (resolve) => {
        const interval = (delay = 5000) => new Promise(resolve => { setTimeout(() => { resolve(); }, delay); });
        try { } catch (error) { }
        let count = 0;
        do {
          count !== 0 && await interval(2000);
          try {
            count = await dispatch('GET_OPERATE_RECORD_NUM') || 0;
          } catch (error) {
            count = 0;
          }
          count > 0 && commit('UPDATE_DOWNLOAD_CENTER_IS_NEW', true);
          commit('UPDATE_DOWNLOAD_CENTER_PROCESSING', count > 0);
        }
        while (count > 0);
        resolve();
      });
    },

    /*************************************************/

    //                    基础交互                    //

    /*************************************************/

    /*****************
     *  获取登陆状态  *
    *****************/
    CHECK_LOGIN ({ dispatch, commit, state }) {
      const url = '/api/community/admin/isLogined';
      const params = {};

      return POST({ dispatch, commit }, url, params).then(() => {
        commit('IS_LOGIN');
        dispatch('GET_ACTIVE_MENU_INDEX');
        dispatch('GET_ACTIVE_ITEM_INDEX');

        dispatch('GET_CITY_COMMUNITY_LIST');

        dispatch('GET_VIRTUAL_COMMUNITY_LIST'); // 登录获取虚拟社区列表
        dispatch('GET_THEME_COMM_TAG_LIST');    // 获取虚拟社区分类列表
        return state.systemInfo.environment === null ? dispatch('GET_SYSTEM_INFO') : Promise.resolve();
      }).catch((res) => {
        commit('NOT_LOGIN');
        return Promise.reject(res);
      });
    },

    /*****************
     *  获取系统信息  *
    *****************/
    GET_SYSTEM_INFO ({ dispatch, commit, state }) {
      const url = '/api/community/admin/systemInfo';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_SYSTEM_INFO', Object.assign({}, data, {
          community: data.community === null ? {} : data.community
        }));
        if (data.defCommunityIds) {
          dispatch('GET_UNREAD_MSG_COUNT');
        }
        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /*****************
     *  获取系统菜单  *
    *****************/
    GET_MENU_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getMenuV2List';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_MENU_LIST', data);
        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /*****************
     *  获取页面权限  *
    *****************/
    GET_IFACE_LIST ({ dispatch, commit }, to) {
      const url = '/api/community/admin/getIfaceList';
      const params = { to };

      return POST({ dispatch, commit }, url, params).then((iface) => {
        commit('SET_IFACE_LIST', { to, iface });
        return Promise.resolve(iface);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /*****************
     *  查询页面权限  *
    *****************/
    CHECK_IFACE_LIST ({ dispatch, commit, state }, to) {
      if (typeof state.ifaceList[to] !== 'undefined') {
        return state.ifaceList[to];
      } else {
        return dispatch('GET_IFACE_LIST', to);
      }
    },

    /**********
     *  登录  *
     **********/
    LOGIN ({ dispatch, commit }, { username, password, captcha } = {}) {
      const url = '/api/community/admin/login';
      const params = { username, password, captcha };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('IS_LOGIN');
        dispatch('REMOVE_ACTIVE_MENU_INDEX');
        dispatch('REMOVE_ACTIVE_ITEM_INDEX');
        dispatch('GET_UNREAD_MSG_COUNT');

        dispatch('GET_CITY_COMMUNITY_LIST');
        dispatch('GET_THEME_COMM_TAG_LIST');

        return dispatch('GET_SYSTEM_INFO');
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /**********
     *  注销  *
     **********/
    LOGOUT ({ dispatch, commit }) {
      const url = '/api/community/admin/logout';

      return POST({ dispatch, commit }, url, {}).then((data) => {
        commit('HAS_LOGGED_OUT');
      }).catch(() => {
        commit('HAS_LOGGED_OUT');
      });
    },

    /**************
     *  修改密码  *
     **************/
    EDIT_PASSWORD ({ dispatch, commit }, { oldPassword, newPassword, smsCaptcha } = {}) {
      const url = '/api/community/admin/updateMyPassword';
      const params = { oldPassword, newPassword, smsCaptcha };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  更新用户协议状态  *
     *********************/
    UPDATE_AGREE ({ dispatch, commit }) {
      const url = '/api/community/admin/agreeProtocol';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        dispatch('GET_SYSTEM_INFO');

        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /*******************************
     *  获取当前顶部菜单激活项Index  *
     *******************************/
    GET_ACTIVE_MENU_INDEX ({ dispatch, commit }) {
      const { content } = new CH('rfcommunity__community_menu_active');
      commit('SET_ACTIVE_MENU_INDEX', content);
      return content;
    },

    /*******************************
     *  记录当前顶部菜单激活项Index  *
     *******************************/
    SET_ACTIVE_MENU_INDEX ({ dispatch, commit }, index) {
      let r = new CH('rfcommunity__community_menu_active');
      r.set(index, 30 * 24 * 60 * 60 * 1000);     // 30 days

      commit('SET_ACTIVE_MENU_INDEX', index);
      return Promise.resolve();
    },

    /*******************************
     *  清空当前顶部菜单激活项Index  *
     *******************************/
    REMOVE_ACTIVE_MENU_INDEX ({ dispatch, commit }) {
      CH.remove('rfcommunity__community_menu_active');

      commit('SET_ACTIVE_MENU_INDEX', 0);
      return Promise.resolve();
    },

    /*****************************
     *  获取当前菜单栏激活项Index  *
     *****************************/
    GET_ACTIVE_ITEM_INDEX ({ dispatch, commit }) {
      const { content } = new CH('rfcommunity__community_item_active');
      commit('SET_ACTIVE_ITEM_INDEX', content + '');
      return content;
    },

    /*****************************
     *  记录当前菜单栏激活项Index  *
     *****************************/
    SET_ACTIVE_ITEM_INDEX ({ dispatch, commit }, index) {
      let r = new CH('rfcommunity__community_item_active');
      r.set(index + '', 30 * 24 * 60 * 60 * 1000);     // 30 days

      commit('SET_ACTIVE_ITEM_INDEX', index + '');
      return Promise.resolve();
    },

    /*****************************
     *  清空当前菜单栏激活项Index  *
     *****************************/
    REMOVE_ACTIVE_ITEM_INDEX ({ dispatch, commit }) {
      CH.remove('rfcommunity__community_item_active');

      commit('SET_ACTIVE_ITEM_INDEX', '0');
      return Promise.resolve();
    },

    /*************************************************/

    //                    2.00 API                   //

    /*************************************************/

    /**************
     *  员工列表  *
     **************/
    GET_ADMIN_LIST ({ dispatch, commit }, { index = 1, size = 10, status, username, realname, phone, tel, roleId, deptId, adminId,
      startCreateTime, endCreateTime, startLatestLoginTime, endLatestLoginTime, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getAdminList';
      const params = {
        index, size, status, username, realname, phone, tel, roleId, deptId, adminId,
        startCreateTime, endCreateTime, startLatestLoginTime, endLatestLoginTime, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  获取员工  *
     **************/
    GET_ADMIN ({ dispatch, commit }, { adminId = '' } = {}) {
      const url = '/api/community/admin/getAdmin';
      const params = { adminId };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  添加员工  *
     **************/
    CREATE_ADMIN ({ dispatch, commit }, { realname, phone, email, dept, status, roleId, communityIds } = {}) {
      const url = '/api/community/admin/addAdmin';
      const params = { realname, phone, email, dept, status, roleId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  修改员工  *
     **************/
    EDIT_ADMIN ({ dispatch, commit }, { adminId, status, roleId, communityIds } = {}) {
      const url = '/api/community/admin/editAdmin';
      const params = { adminId, status, roleId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  删除员工  *
     **************/
    DELETE_ADMIN ({ dispatch, commit }, adminId) {
      const url = '/api/community/admin/deleteAdmin';
      const params = { adminId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取角色列表  *
     ******************/
    GET_ADMIN_SYS_ROLE_LIST ({ dispatch, commit }, { index = 1, size = 10, name = '', status = 0 } = {}) {
      const url = '/api/community/admin/getSysRoleList4PassportMgPg';
      const params = { index, size, name, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  更改员工密码  *
     *****************/
    UPDATE_ADMIN_PASSWORD ({ dispatch, commit }, { adminId, newPassword } = {}) {
      const url = '/api/community/admin/updateAdminPassword';
      const params = { adminId, newPassword };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  更改员工状态  *
     *****************/
    UPDATE_ADMIN_STATUS ({ dispatch, commit }, { adminId, status } = {}) {
      const url = '/api/community/admin/updateAdminStatus';
      const params = { adminId, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  生成员工密码  *
     *****************/
    RANDOM_ADMIN_PASSWORD ({ dispatch, commit }) {
      const url = '/api/community/admin/randomAdminPassword';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  生成员工账号  *
     *****************/
    GET_SUGGESTED_ADMIN_NAME ({ dispatch, commit }, { loudong, floor, room }) {
      const url = '/api/community/admin/getSuggestedAdminName';
      const params = { loudong, floor, room };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  敏感词列表   *
     ****************/
    GET_SENSITIVE_WORD_LIST ({ dispatch, commit }, { index = 1, size = 10, words } = {}) {
      const url = '/api/community/admin/getSensitiveWordsList';
      const params = { index, size, words };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  获取敏感词  *
     ****************/
    GET_SENSITIVE_WORD ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getSensitiveWords';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  添加敏感词  *
     ****************/
    CREATE_SENSITIVE_WORD ({ dispatch, commit }, { words, rplWords }) {
      const url = '/api/community/admin/addSensitiveWords';
      const params = { words, rplWords };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  修改敏感词  *
     ****************/
    EDIT_SENSITIVE_WORD ({ dispatch, commit }, { id, words, rplWords }) {
      const url = '/api/community/admin/editSensitiveWords';
      const params = { id, words, rplWords };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  删除敏感词  *
     ****************/
    DELETE_SENSITIVE_WORD ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteSensitiveWords';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************
     *  检查敏感词是否存在  *
     **********************/
    DOES_SENSITIVE_WORD_EXIST ({ dispatch, commit }, words) {
      const url = '/api/community/admin/hasSensitiveWords';
      const params = { words };

      return POST({ dispatch, commit }, url, params).then((data) => {
        return data === 1;
      });
    },

    /**************
     *  部门列表   *
     **************/
    GET_SYS_DEPT_LIST ({ dispatch, commit }, { parentId, includeSub = 0, status = 1 }) {
      const url = '/api/community/admin/getSysDeptList';
      const params = { parentId, includeSub, status };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  获取部门   *
     **************/
    GET_SYS_DEPT ({ dispatch, commit }, { id, includeSub = 0 } = {}) {
      const url = '/api/community/admin/getSysDept';
      const params = { id, includeSub };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  添加部门   *
     **************/
    CREATE_SYS_DEPT ({ dispatch, commit }, { areaId, parentId, status, name }) {
      const url = '/api/community/admin/addSysDept';
      const params = { areaId, parentId, status, name };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  编辑部门   *
     **************/
    EDIT_SYS_DEPT ({ dispatch, commit }, { id, areaId, parentId, status, name }) {
      const url = '/api/community/admin/editSysDept';
      const params = { id, areaId, parentId, status, name };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  删除部门   *
     **************/
    DELETE_SYS_DEPT ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteSysDept';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  角色列表  *
     *************/
    GET_SYS_ROLE_LIST ({ dispatch, commit }, { index = 1, size = 10, name = '', status = 0 } = {}) {
      const url = '/api/community/admin/getSysRoleList';
      const params = { index, size, name, status };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  获取角色   *
     **************/
    GET_SYS_ROLE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getSysRole';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  获取角色   *
     **************/
    GET_SYS_ROLE_2 ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getSysRoleV2';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  添加角色   *
     **************/
    CREATE_SYS_ROLE ({ dispatch, commit }, { status, name, resourceIds, remark, weight }) {
      const url = '/api/community/admin/addSysRole';
      const params = { status, name, resourceIds, remark, weight };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  编辑角色   *
     **************/
    EDIT_SYS_ROLE ({ dispatch, commit }, { id, status, name, resourceIds, remark, weight }) {
      const url = '/api/community/admin/editSysRole';
      const params = { id, status, name, resourceIds, remark, weight };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  修改角色状态   *
     ******************/
    EDIT_SYS_ROLE_STATUS ({ dispatch, commit }, { id, status }) {
      const url = '/api/community/admin/editSysRoleStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  删除角色   *
     **************/
    DELETE_SYS_ROLE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteSysRole';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  系统资源列表  *
     *****************/
    GET_SYS_RESOURCE_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getSysResourceList';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        let list = data;
        if (list.length > 0) {
          const l = list.length;
          for (let i = 0; i < l; i++) {                           // Level 1
            list[i].checked_bool = list[i].checked === 1;

            if (list[i].subList.length > 0) {
              const subL = list[i].subList.length;
              for (let j = 0; j < subL; j++) {                   // Level 2
                list[i].subList[j].checked_bool = list[i].subList[j].checked === 1;

                if (list[i].subList[j].subList.length > 0) {
                  const subsubL = list[i].subList[j].subList.length;
                  for (let k = 0; k < subsubL; k++) {             // Level 3
                    list[i].subList[j].subList[k].checked_bool = list[i].subList[j].subList[k].checked === 1;
                  }
                }
              }
            }
          }
        }

        commit('SET_SYS_RESOURCE_LIST', list);
        return data;
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /*****************
     *  系统资源列表  *
     *****************/
    GET_SYS_RESOURCE_LIST_2 ({ dispatch, commit }) {
      const url = '/api/community/admin/getSysResourceV2List';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_SYS_RESOURCE_LIST', data);
        return data;
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /**************
     *  主会员列表  *
     **************/
    GET_MASTER_LIST ({ dispatch, commit }, { index = 1, size = 10, title, loudong, floor, room,
      status, type, tel, chargePhone, propAddr, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/listMasterInfo';
      const params = {
        index, size, title, loudong, floor, room,
        status, type, tel, chargePhone, propAddr, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  获取主会员  *
     **************/
    // GET_MASTER ({ dispatch, commit }, id) {
    //   const url = '/api/community/admin/getMasterInfo';
    //   const params = { id };

    //   return POST({ dispatch, commit }, url, params);
    // },

    /***********************************
     *  根据楼栋、楼层、房间号查询主会员  *
     ***********************************/
    GET_MASTER_BY_ADDR ({ dispatch, commit }, { room, floor, loudong }) {
      const url = '/api/community/admin/getMasterInfoExt';
      const params = { room, floor, loudong };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  添加主会员  *
     **************/
    CREATE_MASTER ({ dispatch, commit }, { username, password, type, communityId,
      title, tel, room, floor, loudong, canVisit, roleCount, chargePhone, chargeName,
      parkingOwnerMasterId, parkingStatus, parkingCarPlateNo, parkingCardNo, parkingRemark,
      parkingTenantName, parkingTenantPhone, parkingTenantStartDate, parkingTenantEndDate,
    } = {}) {
      const url = '/api/community/admin/addMasterInfo';
      const params = {
        username, password, type, communityId,
        title, tel, room, floor, loudong, canVisit, roleCount, chargePhone, chargeName,
        parkingOwnerMasterId, parkingStatus, parkingCarPlateNo, parkingCardNo, parkingRemark,
        parkingTenantName, parkingTenantPhone, parkingTenantStartDate, parkingTenantEndDate,
      };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  修改主会员  *
     **************/
    EDIT_MASTER ({ dispatch, commit }, { id, type, title, tel, room, floor, loudong,
      canVisit, roleCount, chargePhone, chargeName, areaId, address,
      parkingOwnerMasterId, parkingStatus, parkingCarPlateNo, parkingCardNo, parkingRemark,
      parkingTenantName, parkingTenantPhone, parkingTenantStartDate, parkingTenantEndDate
    } = {}) {
      const url = '/api/community/admin/editMasterInfo';
      const params = {
        id, type, title, tel, room, floor, loudong,
        canVisit, roleCount, chargePhone, chargeName, areaId, address,
        parkingOwnerMasterId, parkingStatus, parkingCarPlateNo, parkingCardNo, parkingRemark,
        parkingTenantName, parkingTenantPhone, parkingTenantStartDate, parkingTenantEndDate,
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  重置主会员密码  *
     *******************/
    EDIT_MASTER_PASSWORD ({ dispatch, commit }, { id, newPassword }) {
      const url = '/api/community/admin//updateMasterPassword';
      const params = { id, newPassword };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  更改主会员状态  *
     *******************/
    UPDATE_MASTER_STATUS ({ dispatch, commit }, { id, status }) {
      const url = '/api/community/admin/updateMasterInfoStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  主会员文件列表  *
     *******************/
    GET_MASTER_FILE_LIST ({ dispatch, commit }, id) {
      const url = '/api/community/admin/listMasterFile';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  添加主会员文件  *
     *******************/
    CREATE_MASTER_FILE ({ dispatch, commit }, { masterId, link, name }) {
      const url = '/api/community/admin/addMasterFile';
      const params = { masterId, link, name };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  删除主会员文件  *
     *******************/
    DELETE_MASTER_FILE ({ dispatch, commit }, { masterId, id }) {
      const url = '/api/community/admin/delMasterFile';
      const params = { masterId, id };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取认证会员列表  *
     *********************/
    GET_MEMBER_LIST ({ dispatch, commit }, { index = 1, size = 10, userName, phone, masterId,
      startTime, endTime, gagStatus, regStatus, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getUserList';
      const params = {
        index, size, userName, phone, masterId,
        startTime, endTime, gagStatus, regStatus, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加认证会员  *
     *****************/
    CREATE_MASTER_CHILD ({ dispatch, commit }, { masterId, name, phone, type } = {}) {
      const url = '/api/community/admin/addMasterChild';
      const params = { masterId, name, phone, type };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改认证会员  *
     *****************/
    EDIT_MASTER_CHILD ({ dispatch, commit }, { masterChildId, name, type } = {}) {
      const url = '/api/community/admin/editMasterChildInfo';
      const params = { masterChildId, name, type };

      return POST({ dispatch, commit }, url, params);
    },

    // /************************
    //  *  更改认证会员账号状态  *
    //  ************************/
    // UPDATE_MEMBER_STATUS ({ dispatch, commit }, { masterChildId, status } = {}) {
    //   const url = '/api/community/admin/platform/edit_user_info_status';
    //   const params = { masterChildId, status };

    //   return POST({ dispatch, commit }, url, params);
    // },

    /************************
     *  更改认证会员言论状态  *
     ************************/
    UPDATE_MEMBER_GAG_STATUS ({ dispatch, commit }, { uid, gagStatus }) {
      const url = '/api/community/admin/editGagStatus';
      const params = { uid, gagStatus };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取认证会员物业列表  *
     *************************/
    GET_USER_PROP_LIST ({ dispatch, commit }, phone) {
      const url = '/api/community/admin/getUserPropList';
      const params = { phone };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  更改认证会员房产绑定状态  *
     ****************************/
    UPDATE_USER_PROP_STATUS ({ dispatch, commit }, { masterChildId, status }) {
      const url = '/api/community/admin/editMasterChildStatus';
      const params = { masterChildId, status };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  更改认证会员vip状态  *
     ****************************/
    UPDATE_USER_VIP_STATUS ({ dispatch, commit }, params) {
      const url = '/api/community/admin/openOrCloseMasterChildVip';

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  获取认证会员物业信息 *
     ****************************/

    GET_USER_PROP_INFO ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getUserPropInfo';
      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  更新认证会员物业信息 *
     ****************************/

    UPDATE_USER_PROP_INFO ({ dispatch, commit }, params) {
      const url = '/api/community/admin/updateUserPropInfo';
      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  编辑会员身份  *
     ****************************/
    MODIFY_USER_IDENTITY ({ dispatch, commit }, params) {
      const url = '/api/community/admin/editIdentity';
      // const params = { masterChildId, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取会员积分列表  *
     *********************/
    GET_MEMBER_BONUS_POINT_DETAIL_LIST ({ dispatch, commit }, { index = 1, size = 10, uid } = {}) {
      const url = '/api/community/admin/getBonusPointDetailCompose';
      const params = { index, size, uid };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************************
     *  获取会员积分列表——用户管理专用  *
     **********************************/
    GET_USER_BONUS_POINT_DETAIL_LIST ({ dispatch, commit }, { index = 1, size = 10, uid } = {}) {
      const url = '/api/community/admin/getBonusPointDetailCompose4UserMgt';
      const params = { index, size, uid };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************************
     *  获取会员基础信息  *
     **********************************/
    GET_USER_BASE_INFO ({ dispatch, commit }, masterChildId) {
      const url = '/api/community/admin/getMasterChildInfo';
      const params = { masterChildId };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************************
     *  获取用户车辆列表  *
     **********************************/
    GET_USER_CAR_INFO ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getUserParkCarList';
      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  根据UID获取关注社区列表  *
     ****************************/
    GET_ATTENTION_COMMUNITY_BY_UID ({ dispatch, commit }, { index = 1, size = 2000, uid } = {}) {
      const url = '/api/community/admin/platform/getCommunityAttentionList';
      const params = { index, size, uid };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  获取用户历史物业列表（全部）  *
     ****************************/
    GET_ALL_HISTORY_PROP_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getAllUserHistoryPropList';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  一般会员列表  *
     *****************/
    GET_REG_USER_LIST ({ dispatch, commit }, { index = 1, size = 10, nickname, phone } = {}) {
      const url = '/api/community/admin/platform/userInfoListPager';
      const params = { index, size, nickname, phone };

      return POST({ dispatch, commit }, url, params);
    },

    /********************
     *  更改一般会员状态  *
     ********************/
    UPDATE_USER_STATUS ({ dispatch, commit }, { id, status } = {}) {
      const url = '/api/community/admin/platform/edit_user_info_status';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /********************
     *  更改一般会员言论  *
     ********************/
    UPDATE_USER_GAG_STATUS ({ dispatch, commit }, params) {
      const url = '/api/community/admin/platform/userInfoListPager';
      return POST({ dispatch, commit }, url, params);
    },

    /********************
     *  获取用户注册属性  *
     ********************/
    GET_USER_REGISTER_DATA ({ dispatch, commit }, params) {
      const url = '/api/community/admin/platform/getUserAttribute';
      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  获取粉丝列表  *
     ****************/
    GET_ATTENTION_LIST ({ dispatch, commit }, { index = 1, size = 10, status, category, phone,
      fullname, nickname, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/listCommunityAttention';
      const params = { index, size, category, status, phone, fullname, nickname, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  获取粉丝列表  *
     ****************/
    GET_ATTENTION_LIST_2 ({ dispatch, commit }, { index = 1, size = 10, status, phone,
      fullname, nickname, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/listCommunityAttention2';
      const params = { index, size, status, phone, fullname, nickname, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取会员审核列表  *
     *********************/
    GET_MEMBER_CERT_LIST ({ dispatch, commit }, { index = 1, size = 10,
      propType, masterChildType, auditStatus, name, mobile, startApplyTime, endApplyTime } = {}) {
      const url = '/api/community/admin/getMasterChildCertList';
      const params = { index, size, propType, masterChildType, auditStatus, name, mobile, startApplyTime, endApplyTime };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  通过会员信息  *
     *****************/
    AUDIT_MEMBER_PASS ({ dispatch, commit }, id) {
      const url = '/api/community/admin/passMasterChildCert';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  不通过会员信息  *
     *******************/
    AUDIT_MEMBER_DENY ({ dispatch, commit }, { id, reason }) {
      const url = '/api/community/admin/denyMasterChildCert';
      const params = { id, reason };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************
     *  获取预约/邀约列表  *
     **********************/
    GET_APPOINTMENT_LIST ({ dispatch, commit }, { index = 1, size = 10, type = 0, visit, phone } = {}) {
      const url = '/api/community/admin/listAppointment';
      const params = { index, size, type, visit, phone };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取访客列表  *
     *****************/
    GET_VISIT_INFO_LIST ({ dispatch, commit }, { index = 1, size = 10, master_title, child_name, child_phone,
      loudong, floor, room, start_visit_date, end_visit_date, cityId = null, communityIds = null, id } = {}) {
      const url = '/api/community/admin/listVisit4Info';
      const params = {
        index, size, master_title, child_name, child_phone,
        loudong, floor, room, start_visit_date, end_visit_date, cityId, communityIds, id
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取访客拜访列表详情  *
     *****************/
    GET_VISITOR_VISIT_DETAIL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getVisitApply';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  审批邀约拜访  *
     *****************/
    AUDIT_VISIT_INVITE ({ dispatch, commit }, params) {
      const url = '/api/community/admin/auditVisitInvite';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取访客拜访记录列表  *
     *****************/
    GET_VISITOR_VISIT_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/listVisitApply';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  审批申请拜访  *
     *****************/
    AUDIT_APPLY_VISIT ({ dispatch, commit }, params) {
      const url = '/api/community/admin/auditApplyVisit';
      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取门禁访问记录列表  *
     *************************/
    GET_QR_LOG_LIST ({ dispatch, commit }, { index = 1, size = 10, type = 0, phone } = {}) {
      const url = '/api/community/admin/listQrcodeLogCommunity';
      const params = { index, size, type, phone };

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  获取物品放行列表列表  *
     ************************/
    GET_APPLY_GOODS_LIST ({ dispatch, commit }, { index = 1, size = 10, applicantName, applicantPhone, carrierName, carrierPhone } = {}) {
      const url = '/api/community/admin/listReleaseApplyGoods';
      const params = { index, size, applicantName, applicantPhone, carrierName, carrierPhone };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  审核物品放行  *
     *****************/
    AUDIT_APPLY_GOODS ({ dispatch, commit }, { id, status, auditContent, exePhone }) {    // 2:审核通过 3:审核不通过
      const url = '/api/community/admin/auditReleaseApplyGoods';
      const params = { id, status, auditContent, exePhone };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取门禁开门记录列表  *
     *************************/
    GET_QR_ENTRANCE_LIST ({ dispatch, commit }, { index = 1, size = 10, phone, sys_type, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/listQrcodeLogCommunity2';
      const params = { index, size, phone, sys_type, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  设置社区门禁 -- 拥有门禁服务的社区列表   *
     *************************/
    GET_PAGE_COMMUNITYS_HAS_GUARD_LIST ({ dispatch, commit }, { index = 1, size = 10, timeoutMouth = null, cityId = null, communityId = null } = {}) {
      const url = '/api/community/admin/pageCommunitysHasGuard';
      const params = { index, size, timeoutMouth, cityId, communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  设置社区门禁 -- 设置社区门禁休眠时间    *
     *************************/
    SET_GUARD_SLEEP_CONFIG ({ dispatch, commit }, { communityId = null, timeoutMouth = null } = {}) {
      const url = '/api/community/admin/setGuardSleepConfig';
      const params = { communityId, timeoutMouth };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  设置社区门禁 -- 设置社区门禁休眠时间    *
     *************************/
    SET_ENABLED_GUARD ({ dispatch, commit }, { communityId = null, uid = null } = {}) {
      const url = '/api/community/admin/enableGuard';
      const params = { communityId, uid };

      return POST({ dispatch, commit }, url, params);
    },

    /***************
     *  二维码列表  *
     ***************/
    GET_QR_LIST ({ dispatch, commit }, { index = 1, size = 10, type, isPrint } = {}) {
      const url = '/api/community/admin/listCommunityQrcode';
      const params = { index, size, type, isPrint };

      return POST({ dispatch, commit }, url, params);
    },

    /***************
     *  生成二维码  *
     ***************/
    CREATE_QR ({ dispatch, commit }, { count, validDate } = {}) {
      const url = '/api/community/admin/createCommunityQrcode';
      const params = { count, validDate };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************
     *  获取二维码打印列表  *
     **********************/
    GET_QR_PRINT_LIST ({ dispatch, commit }, ids) {
      const url = '/api/community/admin/listCommunityQrcodePrint';
      const params = { ids };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  卡片信息列表  *
     *****************/
    GET_CARD_INFO_LIST ({ dispatch, commit }, { index = 1, size = 10, category = null, categoryId, templateId, content,
      pubToSquare, auditStatus, subjectType, subjectName, startCreateTime, endCreateTime, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getCardInfoList';
      const params = {
        index, size, category, categoryId, templateId, content,
        pubToSquare, auditStatus, subjectType, subjectName, startCreateTime, endCreateTime, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  商家卡片信息列表  *
     *****************/
    GET_STORE_CARD_INFO_LIST ({ dispatch, commit }, { index = 1, size = 10, templateId,
      pubToSquare, auditStatus, startCreateTime, endCreateTime } = {}) {
      const url = '/api/community/admin/store/getCardInfoList';
      const params = {
        index, size, templateId,
        pubToSquare, auditStatus, startCreateTime, endCreateTime
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  商家卡片--下架申请  *
     *****************/
    SAVE_STORE_AUDITCARD_INFO ({ dispatch, commit }, { id, operation_id, auditStatus, auditReason } = {}) {
      const url = '/api/community/admin/store/auditCardInfo';
      const params = { id, operation_id, auditStatus, auditReason };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  商家卡片--同步到广场申请  *
     *****************/
    SAVE_STORE_PUBTOSQUARE ({ dispatch, commit }, { id, status } = {}) {
      const url = '/api/community/admin/store/pubToSquare';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  商家卡片--卡片详情  *
     *****************/
    GET_STORE_CARE_INFO ({ dispatch, commit }, { id } = {}) {
      const url = '/api/community/admin/store/getCardInfo';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  商家卡片--删除  *
     *****************/
    DELETE_STORE_CARD_INFO ({ dispatch, commit }, { id, operation_id } = {}) {
      const url = '/api/community/admin/store/deleteCardInfo';
      const params = { id, operation_id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取卡片信息  *
     *****************/
    GET_CARD_INFO ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getCardInfo';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加卡片信息  *
     *****************/
    CREATE_CARD_INFO ({ dispatch, commit }, { categoryId, templateId, cityId, communityIds, pubToSquare, content, attachment, reaudit, submitAudit } = {}) {
      const url = '/api/community/admin/addCardInfo';
      const params = { categoryId, templateId, cityId, communityIds, pubToSquare, content, attachment, reaudit, submitAudit };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改卡片信息  *
     *****************/
    EDIT_CARD_INFO ({ dispatch, commit }, { id, categoryId, communityIds, templateId, pubToSquare, content, attachment, reaudit = 0, submitAudit } = {}) {
      const url = '/api/community/admin/editCardInfo';
      const params = { id, categoryId, templateId, communityIds, pubToSquare, content, attachment, reaudit, submitAudit };
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除卡片信息  *
     *****************/
    DELETE_CARD_INFO ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteCardInfo';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /********************
     *  获取卡片审核需求  *
     ********************/
    // GET_CARD_AUDIT ({ dispatch, commit }) {
    //   const url = '/api/community/admin/getCardInfoAudit';
    //   const params = {};

    //   return POST({ dispatch, commit }, url, params).then((data) => {
    //     return data === 1;
    //   });
    // },

    /*****************
     *  审核卡片信息  *
     *****************/
    AUDIT_CARD_INFO ({ dispatch, commit }, { id, auditStatus, auditReason }) {
      const url = '/api/community/admin/auditCardInfo';
      const params = { id, auditStatus, auditReason };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  发布卡片到广场  *
     ******************/
    PUB_TO_SQUARE ({ dispatch, commit }, { id, status }) {
      const url = '/api/community/admin/pubToSquare';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  卡片分类列表  *
     *****************/
    GET_CARD_CATEGORY_LIST ({ dispatch, commit }, { index = 1, size = 10, category = null, status = null, name = null, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getCardCategoryList';
      const params = { index, size, category, status, name, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取卡片分类  *
     *****************/
    GET_CARD_CATEGORY ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getCardCategory';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加卡片分类  *
     *****************/
    CREATE_CARD_CATEGORY ({ dispatch, commit }, { templateId, name, sorting, status, communityIds }) {
      const url = '/api/community/admin/addCardCategory';
      const params = { templateId, name, sorting, status, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改卡片分类  *
     *****************/
    EDIT_CARD_CATEGORY ({ dispatch, commit }, { id, templateId, name, sorting, status, type }) {
      const url = '/api/community/admin/editCardCategory';
      const params = { id, templateId, name, sorting, status, type };

      return POST({ dispatch, commit }, url, params);
    },

    /********************
     *  更新卡片分类状态  *
     ********************/
    UPDATE_CARD_CATEGORY_STATUS ({ dispatch, commit }, { id, status }) {
      const url = '/api/community/admin/updateCardCategoryStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除卡片分类  *
     *****************/
    DELETE_CARD_CATEGORY ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteCardCategory';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  广场卡片列表  *
     *****************/
    GET_SQUARE_CARD_LIST ({ dispatch, commit }, { index = 1, size = 10, subjectName, subjectType, content, squareAuditStatus,
      startCreateTime, endCreateTime, startApplyTime, endApplyTime,
      startSquareAuditTime, endSquareAuditTime, startPublishTime, endPublishTime
    } = {}) {
      const url = '/api/community/admin/platform/getCardInfoList';
      const params = {
        index, size, subjectName, subjectType, content, squareAuditStatus,
        startCreateTime, endCreateTime, startApplyTime, endApplyTime,
        startSquareAuditTime, endSquareAuditTime, startPublishTime, endPublishTime
      };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  获取卡片  *
     **************/
    GET_SQUARE_CARD ({ dispatch, commit }, id) {
      const url = '/api/community/admin/platform/getCardInfo';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  审核卡片  *
     **************/
    AUDIT_SQUARE_CARD ({ dispatch, commit }, { id, auditStatus, auditReason } = {}) {
      const url = '/api/community/admin/platform/auditCardInfo';
      const params = { id, auditStatus, auditReason };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  卡片举报列表  *
     *****************/
    GET_CARD_REPORT_LIST ({ dispatch, commit }, { index = 1, size = 10,
      categoryId, cardContent, rfullname, sfullname,   // r = 举报人, s = 被举报人
      startTime, endTime, status,                 // 0:未审核 1:删除卡片 2:不处理
    } = {}) {
      const url = '/api/community/admin/getCardReportList';
      const params = { index, size, categoryId, cardContent, rfullname, sfullname, startTime, endTime, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  处理卡片举报  *
     *****************/
    AUDIT_CARD_REPORT ({ dispatch, commit }, { id, status }) {
      const url = '/api/community/admin/auditCardReport';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取社区信息  *
     *****************/
    GET_MY_COMMUNITY ({ dispatch, commit }) {
      const url = '/api/community/admin/getMyCommunity';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改社区信息  *
     *****************/
    EDIT_MY_COMMUNITY ({ dispatch, commit }, { address, areaId, type, backgroundUrl, logoUrl, closingTime, openTime, communityId,
      intro, tel, phone, longitude, latitude, topicAudit, businessEmail, businessPerson, businessPhone } = {}) {
      const url = '/api/community/admin/editMyCommunity';
      const params = {
        address, areaId, type, backgroundUrl, logoUrl, closingTime, openTime, communityId,
        intro, tel, phone, longitude, latitude, topicAudit, businessEmail, businessPerson, businessPhone
      };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  修改实体社区话题审核状态  *
     ****************************/
    UPDATE_COMM_TOPIC_AUDIT_STATUS ({ dispatch, commit }, { id, topicAudit } = {}) {
      const url = '/api/community/admin/platform/updateCommunityTopicAudit';
      const params = { id, topicAudit };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  修改虚拟社区话题审核状态  *
     ****************************/
    UPDATE_VIRTUAL_COMM_TOPIC_AUDIT_STATUS ({ dispatch, commit }, { id, topicAudit } = {}) {
      const url = '/api/community/admin/platform/updateVirtualCommunityTopicAudit';
      const params = { id, topicAudit };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取社区资料列表  *
     *********************/
    GET_COMM_LIST ({ dispatch, commit }, { index = 1, size = 10, status, type, address, tag, isRecommend,
      adminName, adminPhone, name, category, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/platform/getCommunityList';
      const params = {
        index, size, status, type, address, tag, isRecommend,
        adminName, adminPhone, name, category, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取社区资料  *
     *****************/
    GET_COMM ({ dispatch, commit }, id) {
      const url = '/api/community/admin/platform/getCommunity';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  新增社区资料  *
     *****************/
    CREATE_COMM ({ dispatch, commit }, { name, phone, tel, areaId, address, intro, topicAudit, category, tag,
      logoUrl, backgroundUrl, status, type, fileUrls, adminPhone, adminRealname, passportIds,
      longitude, latitude, businessEmail, businessPerson, businessPhone } = {}) {
      const url = '/api/community/admin/platform/addCommunity';
      const params = {
        name, phone, tel, areaId, address, intro, topicAudit, category, tag,
        logoUrl, backgroundUrl, status, type, fileUrls, adminPhone, adminRealname, passportIds,
        longitude, latitude, businessEmail, businessPerson, businessPhone,
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  编辑社区资料  *
     *****************/
    EDIT_COMM ({ dispatch, commit }, { id, name, phone, tel, areaId, address, intro, topicAudit, category, tag, passportIds = null,
      logoUrl, backgroundUrl, status, type, fileUrls, longitude, latitude, businessEmail, businessPerson, businessPhone } = {}) {
      const url = '/api/community/admin/platform/editCommunity';
      const params = {
        id, name, phone, tel, areaId, address, intro, topicAudit, category, tag, passportIds,
        logoUrl, backgroundUrl, status, type, fileUrls, longitude, latitude, businessEmail, businessPerson, businessPhone
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除社区资料  *
     *****************/
    DEL_COMM ({ dispatch, commit }, id) {
      const url = '/api/community/admin/platform/deleteCommunity';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  检查社区资料是否需要同步  *
     ****************************/
    CHECK_COMM_SYNC ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/checkMyCommunityChangeStatus';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  从管家获取社区资料  *
     ***********************/
    GET_COMM_SYNC ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/getCommunitySync';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  从管家同步社区资料  *
     ***********************/
    SYNC_COMM_SYNC ({ dispatch, commit }, communityIds) {
      const url = '/api/community/admin/syncCommunityInfoFromCommunitySync';
      const params = { communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  获取管理员信息  *
     *******************/
    GET_PASSPORT_INFO ({ dispatch, commit }, phone) {
      const url = '/api/community/admin/getPassportInfo';
      const params = { phone };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************************************************/

    /*************************
     *  获取虚拟社区分类列表  *
     *************************/
    GET_THEME_COMM_TAG_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/platform/getVirtualCommunityTags';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_THEME_COMM_TAG_LIST', data);
        return Promise.resolve(data);
      });
    },

    /*****************
     *  禁用虚拟社区  *
     *****************/
    DISABLE_THEME_COMM ({ dispatch, commit }, id) {
      const url = '/api/community/admin/platform/disabledCommunity';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },
    /*****************
     *  启用虚拟社区  *
     *****************/
    ENABLE_THEME_COMM ({ dispatch, commit }, id) {
      const url = '/api/community/admin/platform/enabledCommunity';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************************************************/

    /***********************
     *  获取推荐社交圈列表  *
     ***********************/
    GET_COMM_SORT_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/platform/getCommunitySortList';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  设置社交圈推荐排序  *
     ***********************/
    SET_COMM_SORT ({ dispatch, commit }, { id, sort, force }) {
      const url = '/api/community/admin/platform/setCommunitySort';
      const params = { id, sort, force };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************************************************/

    /*****************
     *  获取门禁信息  *
     *****************/
    GET_ENTRANCE_GUARD ({ dispatch, commit }) {
      const url = '/api/community/admin/getEntranceGuard';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改门禁信息  *
     *****************/
    EDIT_ENTRANCE_GUARD ({ dispatch, commit }, { openTime, closingTime, isEntranceGuard, entranceGuardType, followMax, followMust }) {
      const url = '/api/community/admin/editEntranceGuard';
      const params = { openTime, closingTime, isEntranceGuard, entranceGuardType, followMax, followMust };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  广告分类列表  *
     *****************/
    GET_AD_CATEGORY_LIST ({ dispatch, commit }, { index = 1, size = 10, group_id } = {}) {
      const url = '/api/community/admin/getAdCategoryList';
      const params = { index, size, group_id };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_AD_CATEGORY_LIST', data);
        return data;
      });
    },

    /*************
     *  广告列表  *
     *************/
    GET_AD_LIST ({ dispatch, commit }, { group, category, index = 1, size = 10, name = null, status, startTime, endTime, applyAdminName, communityIds,
      startAuditTime, endAuditTime, startPublishTime, endPublishTime, startApplyTime, endApplyTime } = {}) {
      const url = '/api/community/admin/getAdList';
      const params = {
        group, category, index, size, name, status, startTime, endTime, applyAdminName, communityIds,
        startAuditTime, endAuditTime, startPublishTime, endPublishTime, startApplyTime, endApplyTime
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  获取广告  *
     *************/
    GET_AD ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getAd';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  获取广告栏列表  *
     *************/
    GET_AD_CATEGORY_LIST_GROUP_ID ({ dispatch, commit }, { group_id } = {}) {
      const url = '/api/community/admin/getAdCategoryList';
      const params = { group_id };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_AD_CATEGORY_LIST', data);
        return data;
      });
    },

    /*************
     *  获取广告栏列表  新增广告中*
     *************/
    GET_ADD_AD_CATEGORY_LIST_GROUP_ID ({ dispatch, commit }, { group_id } = {}) {
      const url = '/api/community/admin/getAdCategoryList';
      const params = { group_id };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_ADD_AD_CATEGORY_LIST', data);
        return data;
      });
    },

    /*************
     *  获取广告栏列表  列表编辑广告中*
     *************/
    GET_EDIT_AD_CATEGORY_LIST_GROUP_ID ({ dispatch, commit }, { group_id } = {}) {
      const url = '/api/community/admin/getAdCategoryList';
      const params = { group_id };
      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_EDIT_AD_CATEGORY_LIST', data);
        return data;
      });
    },

    /*************
     *  获取广告组别列表  *
     *************/
    GET_AD_CATEGORY_GROUP ({ dispatch, commit }) {
      const url = '/api/community/admin/getAdCategoryGroup';

      return POST({ dispatch, commit }, url);
    },

    /*************
     *   获取默认广告列表  *
     *************/
    GET_DEFAULT_ADLIST ({ dispatch, commit }, { group_id } = {}) {
      const url = '/api/community/admin/getDefaultAdList';
      const params = { group_id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *   获取默认广告  *
     *************/
    GET_DEFAULT_AD ({ dispatch, commit }, { id } = {}) {
      const url = '/api/community/admin/getDefaultAd';
      const params = { id };
      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *   获取服务列表或者店铺列表  *
     *************/
    GET_SEARCH_STORE_LIST ({ dispatch, commit }, { storeName, index, size } = {}) {
      const url = '/api/community/open/bridgeapi/list_store';
      const params = { storeName, index, size };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *   获取商品列表  *
     *************/
    GET_SEARCH_GOODS_LIST ({ dispatch, commit }, { serviceId, goodName, index, size } = {}) {
      const url = '/api/community/open/bridgeapi/list_store_good';
      const params = { serviceId, goodName, index, size };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *   获取虚拟社区列表  *
     *************/
    GET_VIRTUAL_COMMUNITY_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getVirtualCommunityList';
      const params = {};
      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_VIRTUAL_COMMUNITY_LIST', data);
        return data;
      });
    },

    /*************
     *  添加广告  *
     *************/
    CREATE_AD ({ dispatch, commit }, { name, categoryId, communityIds, type, objectVal, intro, startTime, endTime, imgUrl, submitAudit }) {
      const url = '/api/community/admin/addAd';
      const params = { name, categoryId, communityIds, type, objectVal, intro, startTime, endTime, imgUrl, submitAudit };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  编辑广告  *
     *************/
    EDIT_AD ({ dispatch, commit }, { id, name, categoryId, communityIds, type, objectVal, reaudit, intro, startTime, endTime, imgUrl, submitAudit } = {}) {
      const url = '/api/community/admin/editAd';
      const params = { id, name, categoryId, communityIds, type, objectVal, reaudit, intro, startTime, endTime, imgUrl, submitAudit };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  编辑默认广告  *
     *************/
    EDIT_DEFAULT_AD ({ dispatch, commit }, { id, communityIds = null, type, objectVal, imgUrl, intro } = {}) {
      const url = '/api/community/admin/editDefaultAd';
      const params = { id, communityIds, type, objectVal, imgUrl, intro };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  删除广告  *
     *************/
    DELETE_AD ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteAd';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  审核广告  *
     *************/
    AUDIT_AD ({ dispatch, commit }, { id, status, reason }) {    // 2:审核通过 3:审核不通过
      const url = '/api/community/admin/auditAd';
      const params = { id, status, reason };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  调整广告顺序  *
     *****************/
    SORT_AD ({ dispatch, commit }, { id, sorting } = {}) {
      const url = '/api/community/admin/sortAd';
      const params = { id, sorting };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取个人信息  *
     *****************/
    GET_MY_ADMIN ({ dispatch, commit }) {
      const url = '/api/community/admin/getMyAdmin';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改个人信息  *
     *****************/
    EDIT_MY_ADMIN ({ dispatch, commit }, { adminId, username, realname, phone, tel, email, intro, status, deptIds, roleIds, position } = {}) {
      const url = '/api/community/admin/editMyAdmin';
      const params = { adminId, username, realname, phone, tel, email, intro, status, deptIds, roleIds, position };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取个人权限列表  *
     *********************/
    GET_MY_SYS_ROLE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getSysRoleV2ForView';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    推送管理                    //

    /*************************************************/

    /**********************
     *  获取推送消息列表  *
     **********************/
    GET_NOTE_LIST ({ dispatch, commit }, { index = 1, size = 10, status = 0, type = 0, title = '', cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getNotificationList';
      const params = { index, size, status, type, title, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  获取推送消息  *
     ******************/
    GET_NOTE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getNotification';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  新增推送消息  *
     ******************/
    CREATE_NOTE ({ dispatch, commit }, { category, title, content, remark, type, thumb, pushTime, saveType, communityIds } = {}) {
      const url = '/api/community/admin/addNotification';
      const params = { category, title, content, remark, type, thumb, pushTime, saveType, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  编辑推送消息  *
     ******************/
    EDIT_NOTE ({ dispatch, commit }, { id, title, content, remark, type, thumb, pushTime } = {}) {
      const url = '/api/community/admin/editNotification';
      const params = { id, title, content, remark, type, thumb, pushTime };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  删除推送消息  *
     ******************/
    DEL_NOTE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteNotification';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  提交审核  *
     **************/
    SUBMIT_NOTE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/submitAuditNotification';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  审核推送消息  *
     ******************/
    AUDIT_NOTE ({ dispatch, commit }, { id, status, auditRemark }) {
      const url = '/api/community/admin/auditNotification';
      const params = { id, status, auditRemark };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                  社区服务信息                  //

    /*************************************************/

    /*************************
     *  获取社区服务信息列表  *
    **************************/
    GET_COMM_SERVICE_LIST ({ dispatch, commit }, { cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/communityServiceRelaList';
      const params = { cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取所有服务列表  *
    **********************/
    GET_COMM_SERVICE_INFO_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/communityServiceInfoList';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  添加社区服务信息  *
    **********************/
    CREATE_COMM_SERVICE ({ dispatch, commit }, { serviceId, contactWay, remark, reorder, communityIds }) {
      const url = '/api/community/admin/editCommunityServiceRela';                  // The same URI as 'EDIT_COMM_SERVICE'
      const params = { serviceId, contactWay, remark, reorder, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改社区服务信息  *
    **********************/
    EDIT_COMM_SERVICE ({ dispatch, commit }, { serviceId, contactWay, remark, reorder, communityIds }) {
      const url = '/api/community/admin/editCommunityServiceRela';
      const params = { serviceId, contactWay, remark, reorder, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  删除社区服务信息  *
    **********************/
    DELETE_COMM_SERVICE ({ dispatch, commit }, { serviceId, communityIds }) {
      const url = '/api/community/admin/delCommunityServiceRela';
      const params = { serviceId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    数据配对                    //

    /*************************************************/

    /*****************
     *  获取待整理房间列表  *
     *****************/
    GET_LIST_ORIG_MASTER_INFO ({ dispatch, commit }, { communityId = null, loudong = null, floor = null, room = null }) {
      const url = '/api/community/admin/listOrigMasterInfo';
      const params = { communityId, loudong, floor, room };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     * 获取已整理房间列表  *
     *****************/
    GET_LIST_TARGET_MASTER_INFO ({ dispatch, commit }, { communityId = null, loudong = null, floor = null, room = null }) {
      const url = '/api/community/admin/listTargetMasterInfo';
      const params = { communityId, loudong, floor, room };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     * 获取已配对房间列表  *
     *****************/
    GET_LIST_CLEAN_MASTER_INFO ({ dispatch, commit }, { communityId = null, loudong = null, floor = null, room = null }) {
      const url = '/api/community/admin/listCleanMasterInfo';
      const params = { communityId, loudong, floor, room };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     * 获取删除列表  *
     *****************/
    GET_LIST_DELETE_MASTER_INFO ({ dispatch, commit }, { communityId = null, loudong = null, floor = null, room = null }) {
      const url = '/api/community/admin/listDeleteMasterInfo';
      const params = { communityId, loudong, floor, room };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     * 执行配对  *
     *****************/
    DO_UPDATE_MASTER_ID ({ dispatch, commit }, { masterId1, masterId2 = null }) {
      const url = '/api/community/admin/doUpdateMasterId';
      const params = { masterId1, masterId2 };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     * 取消配对  *
     *****************/
    DO_UN_UPDATE_MASTER_ID ({ dispatch, commit }, { masterId1, masterId2 }) {
      const url = '/api/community/admin/doUnUpdateMasterId';
      const params = { masterId1, masterId2 };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     * 标记删除  *
     *****************/
    DO_DELETE_MASTER_ID ({ dispatch, commit }, { masterId }) {
      const url = '/api/community/admin/doDeleteMasterId';
      const params = { masterId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     * 取消标记删除  *
     *****************/
    DO_UN_DELETE_MASTER_ID ({ dispatch, commit }, { masterId }) {
      const url = '/api/community/admin/doUnDeleteMasterId';
      const params = { masterId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取数据匹配城市列表  *
     *********************/
    GET_MATCH_CITY_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getOrigCityCommunityList';

      return POST({ dispatch, commit }, url).then((data) => {
        commit('SET_CITY_COMMUNITY_LIST_MATCH', data);
        return data;
      });
    },

    /*************************************************/

    //                    送水服务                    //

    /*************************************************/

    /*****************
     *  获取楼栋列表  *
     *****************/
    GET_WATER_SUPPLY_BUILDING_LIST ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/getWaterSupplyBuildingList';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
    *  获取房间列表  *
    *****************/
    GET_WATER_SUPPLY_ROOM_LIST ({ dispatch, commit }, { communityId, building }) {
      const url = '/api/community/admin/getWaterSupplyRoomList';
      const params = { communityId, building };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
    *  获取品牌列表  *
    *****************/
    GET_WATER_BRAND_LIST ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/getWaterBrandList';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
    *  获取水票列表  *
    *****************/
    GET_WATER_TICKET_LIST ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/getWaterTicketList';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params);
    },

    // 饮用水管理
    /*******************
     *  获取饮用水列表  *
     *******************/
    GET_WATER_SUPPLY_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getWaterSupplyList';
      const params = { index, size, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /***************
     *  添加饮用水  *
     ***************/
    CREATE_WATER_SUPPLY ({ dispatch, commit }, { type, waterBrandId, name, amount, capacity, deposit, communityId,
      num, startDate, endDate, remark, intro } = {}) {
      const url = '/api/community/admin/addWaterSupply';
      const params = {
        type, waterBrandId, name, amount, capacity, deposit, communityId,
        num, startDate, endDate, remark, intro
      };

      return POST({ dispatch, commit }, url, params);
    },

    /***************
     *  修改饮用水  *
     ***************/
    EDIT_WATER_SUPPLY ({ dispatch, commit }, { id, name, num, amount, capacity, deposit, startDate, endDate, remark, intro }) {
      const url = '/api/community/admin/editWaterSupply';
      const params = { id, name, num, amount, capacity, deposit, startDate, endDate, remark, intro };

      return POST({ dispatch, commit }, url, params);
    },

    /***************
     *  删除饮用水  *
     ***************/
    DELETE_WATER_SUPPLY ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteWaterSupply';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  更改饮用水状态  *
     *******************/
    UPDATE_WATER_SUPPLY_STATUS ({ dispatch, commit }, id) {
      const url = '/api/community/admin/updateWaterSupplyStatus';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  Enable饮用水  *
     *******************/
    ENABLE_WATER_SUPPLY_STATUS ({ dispatch, commit }, id) {
      const url = '/api/community/admin/enableWaterSupplyStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  Disable饮用水  *
     *******************/
    DISABLE_WATER_SUPPLY_STATUS ({ dispatch, commit }, id) {
      const url = '/api/community/admin/disableWaterSupplyStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    // 订单管理
    /*****************
     *  获取订单列表  *
     *****************/
    GET_WATER_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      roomId, orderType, waterBrandId, orderStatus, startDate, endDate }) {
      const url = '/api/community/admin/getWaterOrderList';
      const params = {
        index, size, cityId, communityIds,
        roomId, orderType, waterBrandId, orderStatus, startDate, endDate
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  添加订单  *
     *************/
    CREATE_WATER_ORDER ({ dispatch, commit }, { communityId, roomId, contact, phone, orderType, waterBrandId, num, remark, orderTime } = {}) {
      const url = '/api/community/admin/addWaterOrder';
      const params = { communityId, roomId, contact, phone, orderType, waterBrandId, num, remark, orderTime };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  指派送水人员  *
     *****************/
    ASSIGN_STAFF_WATER_ORDER ({ dispatch, commit }, { id, staffName, staffPhone }) {
      const url = '/api/community/admin/assignStaff';
      const params = { id, staffName, staffPhone };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  编辑送水人员  *
     *****************/
    EDIT_STAFF_WATER_ORDER ({ dispatch, commit }, { id, staffName, staffPhone }) {
      const url = '/api/community/admin/editStaff';
      const params = { id, staffName, staffPhone };

      return POST({ dispatch, commit }, url, params);
    },

    /**********
     *  取水  *
     **********/
    TAKE_WATER ({ dispatch, commit }, id) {
      const url = '/api/community/admin/takeWater';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  送水完成  *
     **************/
    FINISH_TAKE_WATER ({ dispatch, commit }, id) {
      const url = '/api/community/admin/finishTakeWater';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  财务确认收到水票  *
     *********************/
    RECEIPT_TICKET ({ dispatch, commit }, id) {
      const url = '/api/community/admin/receiptTicket';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**********
     *  取票  *
     **********/
    ISSUE_WATER_TICKET ({ dispatch, commit }, id) {
      const url = '/api/community/admin/issueTicket';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  送票完成  *
     **************/
    FINISH_ISSUE_WATER_TICKET ({ dispatch, commit }, id) {
      const url = '/api/community/admin/finishIssueTicket';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  拒收订单  *
     *************/
    REFUSE_WATER_ORDER ({ dispatch, commit }, id) {
      const url = '/api/community/admin/refuseWaterOrder';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  取消订单  *
     *************/
    CANCEL_WATER_ORDER ({ dispatch, commit }, id) {
      const url = '/api/community/admin/cancelWaterOrder';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  导出订单列表  *
     *****************/
    EXPORT_WATER_ORDER_LIST ({ dispatch, commit }, { orderType, orderStatus, startDate, endDate } = {}) {
      const url = '/api/community/admin/exportWaterOrder';
      const params = { orderType, orderStatus, startDate, endDate };

      return POST({ dispatch, commit }, url, params);
    },

    // 送水配置

    /*****************
     *  获取送水配置  *
     *****************/
    GET_WATER_SETTING ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/getWaterCfg';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改送水配置  *
     *****************/
    EDIT_WATER_SETTING ({ dispatch, commit }, { communityId, interval }) {
      const url = '/api/community/admin/editWaterCfg';
      const params = { communityId, interval };

      return POST({ dispatch, commit }, url, params);
    },

    // 押金
    /*****************
     *  获取押金列表  *
     *****************/
    GET_WATER_DEPOSIT_LIST ({ dispatch, commit }, { index = 1, size = 10, status = 0, cityId = null, communityIds = null,
      waterBrandId = 0, building, roomId, contact, phone, payTime, refundTime } = {}) {
      const url = '/api/community/admin/getWaterDepositList';
      const params = {
        index, size, status, cityId, communityIds,
        waterBrandId, building, roomId, contact, phone, payTime, refundTime
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加押金记录  *
     *****************/
    CREATE_WATER_DEPOSIT ({ dispatch, commit }, { communityId, waterBrandId, roomId, contact, phone, payTime, amount, remark, roomOwner } = {}) {
      const url = '/api/community/admin/addWaterDeposit';
      const params = { communityId, waterBrandId, roomId, contact, phone, payTime, amount, remark, roomOwner };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改押金记录  *
     *****************/
    EDIT_WATER_DEPOSIT ({ dispatch, commit }, { id, remark } = {}) {
      const url = '/api/community/admin/editWaterDeposit';
      const params = { id, remark };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  退还押金  *
     **************/
    REFUND_WATER_DEPOSIT ({ dispatch, commit }, { id, refundTime } = {}) {
      const url = '/api/community/admin/refundWaterDeposit';
      const params = { id, refundTime };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  导出押金列表  *
     *****************/
    EXPORT_WATER_DEPOSIT_LIST ({ dispatch, commit }, { waterBrandId = 0, exportType, startDate, endDate } = {}) {
      const url = '/api/community/admin/exportWaterDeposit';
      const params = { waterBrandId, exportType, startDate, endDate };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    意见报修                    //

    /*************************************************/

    /*****************************
     *  获取意见/报修问题类型列表  *
     *****************************/
    GET_REPAIR_PROBLEM_TYPE_LIST ({ dispatch, commit }) {
      const url = '/api/repair/problem_types';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_REPAIR_PROBLEM_TYPE_LIST', data);
        return Promise.resolve(data);
      }).catch((res) => {
        return Promise.reject(res);
      });
    },

    /**************************************
     *  获取外部系统的意见/报修问题类型列表  *
     **************************************/
    GET_OUTER_PROBLEM_TYPE_LIST ({ dispatch, commit }) {
      const url = '/api/repair/outer_problem_types';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*****************************
     *  获取意见/报修问题类型列表  *
     *****************************/
    CREATE_REPAIR_PROBLEM_TYPE ({ dispatch, commit }, { outer_id, name, display_name, sequence }) {
      const url = '/api/repair/create_problem_type';
      const params = { outer_id, name, display_name, sequence };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************************
     *  编辑意见/报修问题类型列表  *
     *****************************/
    EDIT_REPAIR_PROBLEM_TYPE ({ dispatch, commit }, { id, outer_id, name, display_name, sequence, status }) {
      const url = '/api/repair/edit_problem_type';
      const params = { id, outer_id, name, display_name, sequence, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取意见/报修工单列表  *
     *************************/
    GET_REPAIR_LIST ({ dispatch, commit }, { index = 1, size = 10, qualityType = null, status = null, contact, contact_mobile, form_type = 0,
      address, problem_type_id, trade_no, start_date, end_date, cityId = null, communityIds = null } = {}) {
      const url = '/api/repair/list';
      const params = {
        index, size, qualityType, status, contact, contact_mobile, form_type,
        address, problem_type_id, trade_no, start_date, end_date, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取意见/报修工单详情  *
     *************************/
    GET_REPAIR_DETAIL ({ dispatch, commit }, trade_no) {
      const url = '/api/repair/detail';
      const params = { trade_no };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取意见/报修工单进度  *
     *************************/
    GET_REPAIR_PROGRESS ({ dispatch, commit }, trade_no) {
      const url = '/api/repair/progress';
      const params = { trade_no };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    场地预约                    //

    /*************************************************/

    //  服务类型

    /*********************
     *  获取服务类型列表  *
     *********************/
    GET_VENUE_SERVICE_TYPE_LIST ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/venueServiceTypeList';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_VENUE_SERVICE_TYPE_LIST', data);
        return data;
      });
    },

    /*****************
     *  添加服务类型  *
     *****************/
    CREATE_VENUE_SERVICE_TYPE ({ dispatch, commit }, { title, communityId }) {
      const url = '/api/community/admin/addVenueServiceType';
      const params = { title, communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改服务类型  *
     *****************/
    EDIT_VENUE_SERVICE_TYPE ({ dispatch, commit }, { id, title }) {
      const url = '/api/community/admin/editVenueServiceType';
      const params = { id, title };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除服务类型  *
     *****************/
    DELETE_VENUE_SERVICE_TYPE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/delVenueServiceType';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    // 场地
    /*****************
     *  获取场地列表  *
     *****************/
    GET_VENUE_INFO_LIST ({ dispatch, commit }, { index = 1, size = 10, title, serviceType, status,
      chargeType, cityId = null, communityIds = null }) {
      const url = '/api/community/admin/venuesInfoList';
      const params = { index, size, title, serviceType, status, chargeType, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  添加场地  *
     *************/
    CREATE_VENUE_INFO ({ dispatch, commit }, { title, chargeType, intro, reorder, serviceType, communityId,
      businessBegin, businessEnd, weekPart, address }) {
      const url = '/api/community/admin/addVenueInfo';
      const params = {
        title, chargeType, intro, reorder, serviceType, communityId,
        businessBegin, businessEnd, weekPart, address
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  修改场地  *
     *************/
    EDIT_VENUE_INFO ({ dispatch, commit }, { id, title, chargeType, intro, reorder, serviceType,
      businessBegin, businessEnd, weekPart, address }) {
      const url = '/api/community/admin/editVenueInfo';
      const params = {
        id, title, chargeType, intro, reorder, serviceType,
        businessBegin, businessEnd, weekPart, address
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  更新场地状态  *
     *****************/
    UPDATE_VENUE_STATUS ({ dispatch, commit }, { id, status }) {
      const url = '/api/community/admin/updateVenueStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params).then((data) => {
        dispatch('GET_ENABLED_VENUE_LIST');
        return data;
      });
    },

    /*************
     *  删除场地  *
     *************/
    DELETE_VENUE_INFO ({ dispatch, commit }, id) {
      const url = '/api/community/admin/delVenueInfo';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************************
     *  获取场地信息 - 按时间段计费  *
     *******************************/
    GET_TYPE_DATE_VENUE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getVenueChargeTypeByDate';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************************
     *  修改场地信息 - 按时间段计费  *
     *******************************/
    EDIT_TYPE_DATE_VENUE ({ dispatch, commit }, { id, defPrice, array }) {
      const url = '/api/community/admin/updateVenueChargeTypeByDate';
      const params = { id, defPrice, array };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************************
     *  获取场地信息 - 按次数计费  *
     *****************************/
    GET_TYPE_TIMES_VENUE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getVenueChargeTypeByTimes';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************************
     *  修改场地信息 - 按次数计费  *
     *****************************/
    EDIT_TYPE_TIMES_VENUE ({ dispatch, commit }, { id, children, adult }) {
      const url = '/api/community/admin/updateVenueChargeTypeByTimes';
      const params = { id, children, adult };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取场地暂停营业信息  *
     *************************/
    GET_VENUE_PAUSE_TIME ({ dispatch, commit }, id) {
      const url = '/api/community/admin/listVenueFilterTime';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  添加场地暂停营业信息  *
     *************************/
    CREATE_VENUE_PAUSE_TIME ({ dispatch, commit }, { id, startDate, endDate }) {
      const url = '/api/community/admin/addVenueFilterTime';
      const params = { id, startDate, endDate };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  删除场地暂停营业信息  *
     *************************/
    DELETE_VENUE_PAUSE_TIME ({ dispatch, commit }, id) {
      const url = '/api/community/admin/delVenueFilterTime';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    // 订单
    /*****************
     *  获取订单列表  *
     *****************/
    GET_VENUE_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, venueId, status, payStatus, cityId = null, communityIds = null,
      orderName, orderPhone, reservationChannels, verifyCode } = {}) {
      const url = '/api/community/admin/listVenueOrder';
      const params = {
        index, size, venueId, status, payStatus, cityId, communityIds,
        orderName, orderPhone, reservationChannels, verifyCode
      };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取有效的场地列表  *
     **********************/
    GET_ENABLED_VENUE_LIST ({ dispatch, commit }, { index = 1, size = 1000, communityId } = {}) {
      const url = '/api/community/admin/listVenueInfoByEnabled';
      const params = { index, size, communityId };

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_ENABLED_VENUE_LIST', data);
        return data;
      });
    },

    /*************************
     *  获取可预定的场地信息  *
     ************************/
    GET_VENUE_BOOKING_INFO ({ dispatch, commit }, venueId) {
      const url = '/api/community/admin/canHireVenueInfo';
      const params = { venueId };

      return POST({ dispatch, commit }, url, params);
    },

    /******************************
     *  获取指定日期的场地预约信息  *
     ******************************/
    GET_VENUE_BOOKING_DATA_LIST ({ dispatch, commit }, { venueId, date }) {
      const url = '/api/community/admin/hireVenueDataList';
      const params = { venueId, date };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  添加场地线下订单  *
     *********************/
    CREATE_VENUE_ORDER ({ dispatch, commit }, { venueId, date, orderName, orderPhone, extend }) {
      const url = '/api/community/admin/submitVenueOrderOffline';
      const params = { venueId, date, orderName, orderPhone, extend };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  取消场地线下订单  *
     *********************/
    CANCEL_VENUE_ORDER ({ dispatch, commit }, orderId) {
      const url = '/api/community/admin/cancelVenueOrderOffline';
      const params = { orderId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  核销订单  *
     *************/
    WRITE_OFF_VENUE_ORDER ({ dispatch, commit }, { communityId, verifyCode }) {
      const url = '/api/community/admin/useVenueOrderByVerifyCode';
      const params = { communityId, verifyCode };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    物业缴费                    //

    /*************************************************/

    /*******************************
     *  获取楼栋列表 - 缴费系统专用  *
     *******************************/
    UPDATE_PAYMENT_BILL_STATUS ({ dispatch, commit }, { bill_id, status } = {}) {
      const url = '/api/community/admin/payment/updatePaymentBillStatus';
      const params = { bill_id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************************
     *  获取楼栋列表 - 缴费系统专用  *
     *******************************/
    GET_PAYMENT_BUILDING_LIST ({ dispatch, commit }, { index = 1, size = 1000, communityId, type = '' } = {}) {
      const url = '/api/community/admin/payment/getBuildList';
      const params = { index, size, type };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************************
     *  获取房间列表 - 缴费系统专用  *
     *******************************/
    GET_PAYMENT_ROOM_LIST ({ dispatch, commit }, { index = 1, size = 1000, communityId, build = null } = {}) {
      const url = '/api/community/admin/payment/getHousesByBuild';
      const params = { index, size, build };

      return POST({ dispatch, commit }, url, params);
    },

    // 账单

    /*****************
     *  获取账单列表  *
     *****************/
    GET_PAYMENT_BILL_LIST ({ dispatch, commit }, { index = 1, size = 10, houses_type, build, floor, room,
      fee_project, status, start_time, end_time, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/payment/getPaymentBillList';
      const params = {
        index, size, houses_type, build, floor, room,
        fee_project, status, start_time, end_time, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  账单导入  *
     *************/
    IMPORT_PAYMENT_BILL_LIST ({ dispatch, commit }, { file, houses_type }) {
      const url = '/api/community/admin/payment/importPaymentBill';
      const params = { file, houses_type };

      return POST({ dispatch, commit }, url, params);
    },

    /******************************
     *  获取未对接乐天系统社区列表  *
     ******************************/
    GET_ZIZAI_BILL_COMM_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getZiZaiCommunityList';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    // 订单

    /*****************
     *  获取订单列表  *
     *****************/
    GET_PAYMENT_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, bill_id, out_trade_no, bill_status, owner_name, phone,
      start_time, end_time, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/payment/getPaymentBillAndOrderList';
      const params = {
        index, size, bill_id, out_trade_no, bill_status, owner_name, phone,
        start_time, end_time, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  导出缴费记录  *
     *****************/
    EXPORT_PAYMENT_ORDER_LIST ({ dispatch, commit }, { start_time, end_time }) {
      const url = '/api/community/admin/payment/exportPaymentBillAndOrder';
      const params = { start_time, end_time };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  导出结算清单  *
     *****************/
    EXPORT_PAYMENT_STATEMENT ({ dispatch, commit }, { start_time, end_time }) {
      const url = '/api/community/admin/payment/exportStatement';
      const params = { start_time, end_time };

      return POST({ dispatch, commit }, url, params);
    },

    /*************
     *  导出报表  *
     *************/
    EXPORT_PAYMENT_REPORT ({ dispatch, commit }, { start_time, end_time }) {
      const url = '/api/community/admin/payment/exportReport';
      const params = { start_time, end_time };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    财务管理                    //

    /*************************************************/

    /*****************
     *  获取服务列表  *
     *****************/
    GET_EXPORT_SERVICE_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getExportCommunityService';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    系统日志                    //

    /*************************************************/

    /*****************
     *  获取日志列表  *
     *****************/
    GET_LOG_LIST ({ dispatch, commit }, { index = 1, size = 10, startOperTime, endOperTime, searchContent, operName } = {}) {
      const url = '/api/community/admin/getOperLogList';
      const params = { index, size, startOperTime, endOperTime, searchContent, operName };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    消息盒子                    //

    /*************************************************/

    /*****************
     *  获取消息列表  *
     *****************/
    GET_SYS_MSG_LIST ({ dispatch, commit }, { index = 1, size = 10 } = {}) {
      const url = '/api/community/admin/sysMsgInfoIndex';
      const params = { index, size };

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  获取未读盒子消息数量  *
     ************************/
    GET_UNREAD_MSG_COUNT ({ dispatch, commit }) {
      const url = '/api/community/admin/sysMsgInfoIndexUnreadTotal';
      const params = {};

      return POST({ dispatch, commit }, url, params).then(({ unreadTotal, sysNotice, msgInfo }) => {
        commit('SET_UNREAD_MSG_COUNT', unreadTotal);
        commit('SET_UNREAD_NOTICE_COUNT', sysNotice);
        commit('SET_UNREAD_MSG_INFO_COUNT', msgInfo);
        return unreadTotal;
      });
    },

    /**********************
     *  设置盒子消息为已读  *
     **********************/
    SET_MSG_READ ({ dispatch, commit }, id) {
      const url = '/api/community/admin/sysMsgInfoUpdateRead';
      const params = { id };

      return POST({ dispatch, commit }, url, params).then((data) => {
        dispatch('GET_UNREAD_MSG_COUNT');
        return Promise.resolve(data);
      });
    },

    /*************************************************/

    //                    系统消息                    //

    /*************************************************/

    /*****************
     *  系统消息列表  *
     *****************/
    GET_SYS_NOTICE_LIST ({ dispatch, commit }, { index = 1, size = 10 }) {
      const url = '/api/community/admin/listSysNotice';
      const params = { index, size };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  已发送消息列表  *
     *******************/
    GET_SENT_SYS_NOTICE_LIST ({ dispatch, commit }, { index = 1, size = 10, title = '' }) {
      const url = '/api/community/admin/sendingListSysNotice';
      const params = { index, size, title };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  已收到消息列表  *
     *******************/
    GET_RECEIVED_SYS_NOTICE_LIST ({ dispatch, commit }, { index = 1, size = 10, title = '' }) {
      const url = '/api/community/admin/receiveListSysNotice';
      const params = { index, size, title };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取系统消息  *
     *****************/
    GET_SYS_NOTICE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getSysNotice';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  获取未读系统消息数量  *
     ************************/
    GET_UNREAD_NOTICE_COUNT ({ dispatch, commit }) {
      const url = '/api/community/admin/unReadSysNoticeCount';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /**********************
     *  设置系统消息为已读  *
     **********************/
    SET_NOTICE_READ ({ dispatch, commit }, id) {
      const url = '/api/community/admin/sysNoticeUpdateRead';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加系统消息  *
     *****************/
    CREATE_SYS_NOTICE ({ dispatch, commit }, { title, content, pushPlatform = -1, pushCommunity = -1, pushMaster = -1, pushSeller = -1, submit } = {}) {
      const url = '/api/community/admin/addSysNotice';
      const params = { title, content, pushPlatform, pushCommunity, pushMaster, pushSeller, submit };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改系统消息  *
     *****************/
    EDIT_SYS_NOTICE ({ dispatch, commit }, { id, title, content, pushPlatform, pushCommunity, pushMaster, pushSeller } = {}) {
      const url = '/api/community/admin/editSysNotice';
      const params = { id, title, content, pushPlatform, pushCommunity, pushMaster, pushSeller };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  发布系统消息  *
     *****************/
    SUBMIT_SYS_NOTICE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/updateSysNoticeStatus';
      const params = { id, status: 1 };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除系统消息  *
     *****************/
    DELETE_SYS_NOTICE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteSysNotice';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /************************************************************************************/

    /*************************************************/

    //                    CBRE管家服务                    //

    /*************************************************/

    /*****************
     *  获取服务信息  *
     *****************/
    GET_COMM_SERVICE ({ dispatch, commit }, id) {
      const url = '/api/community/open/bridgeapi/getCommunityServiceInfo';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    服务市场                    //

    /*************************************************/

    /*********************
     *  获取服务类型列表  *
     *********************/
    GET_SERVICE_CATEGORY_LIST ({ dispatch, commit }, { index = 1, size = 10 }) {
      const url = '/api/community/admin/getCommunityServiceCategoryList';
      const params = { index, size };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取服务市场列表  *
     *********************/
    GET_SERVICE_MARKET_LIST ({ dispatch, commit }, { index = 1, size = 10, categoryId, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/open/bridgeapi/getCommunityServiceList';
      const params = { index, size, categoryId, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取虚拟社区列表数据(用以构建查询条件)  *
     *********************/
    // GET_VIRTUAL_COMMUNITY_LIST ({ dispatch, commit }, {} = {}) {
    //   const url = '/api/community/admin/getVirtualCommunityList';

    //   debugger
    //   return POST({ dispatch, commit }, url);
    // },

    /*********************
     *  获取服务用户评论  *
     *********************/
    GET_SERVICE_COMMENT_LIST ({ dispatch, commit }, { id, index = 1, size = 10 }) {
      const url = '/api/community/open/bridgeapi/getServiceComment';
      const params = { id, index, size };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取服务联系人信息  *
     ***********************/
    GET_SERVICE_CONTACT ({ dispatch, commit }, { id, communityIds }) {
      const url = '/api/community/open/bridgeapi/getServiceContacts';
      const params = { id, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  选用服务  *
     **************/
    SELECT_SERVICE ({ dispatch, commit }, { id, communityIds }) {
      const url = '/api/community/open/bridgeapi/communitySelectService';
      const params = { id, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /************************************************************************************/

    /*********************
     *  获取服务申请列表  *
     *********************/
    GET_SERVICE_APPLY_LIST ({ dispatch, commit }, { index = 1, size = 10, categoryId, merchantId, merchantName, cityId = null, communityIds = null,
      merchantType, serviceName, communityAuditStatus, startApplyTime, endApplyTime } = {}) {
      const url = '/api/community/admin/getServiceApplyList';
      const params = {
        index, size, categoryId, merchantId, merchantName, cityId, communityIds,
        merchantType, serviceName, communityAuditStatus, startApplyTime, endApplyTime
      };

      return POST({ dispatch, commit }, url, params);
    },

    /******************
     *  审核服务申请  *
     ******************/
    AUDIT_SERVICE_APPLY ({ dispatch, commit }, { id, communityAuditStatus, communityAuditComment, communityIds,
      interviewTime, interviewAddress, businessPerson, businessPhone, businessEmail }) {
      const url = '/api/community/admin/serviceApplyAudit';
      const params = {
        id, communityAuditStatus, communityAuditComment, communityIds,
        interviewTime, interviewAddress, businessPerson, businessPhone, businessEmail
      };

      return POST({ dispatch, commit }, url, params);
    },

    /************************************************************************************/

    /*********************
     *  获取我的服务列表  *
     *********************/
    GET_MY_SERVICE_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      categoryId = null, merchantName = null, merchantType = null, serviceName = null, communityServiceStatus = null } = {}) {
      const url = '/api/community/open/bridgeapi/getMyServiceList';
      const params = {
        index, size, cityId, communityIds, categoryId,
        merchantName, merchantType, serviceName, communityServiceStatus
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改服务排序  *
     *****************/
    UPDATE_MY_SERVICE_ORDER ({ dispatch, commit }, { id, communityIds, communityServiceReorder }) {
      const url = '/api/community/open/bridgeapi/updateServiceReorder';
      const params = { id, communityIds, communityServiceReorder };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改菜单显示状态  *
     *********************/
    UPDATE_MY_SERVICE_MENU_SHOW ({ dispatch, commit }, { id, communityIds, isMenuShow }) {
      const url = '/api/community/open/bridgeapi/updateMenuShow';
      const params = { id, communityIds, isMenuShow };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改服务状态  *
     *****************/
    UPDATE_MY_SERVICE_STATUS ({ dispatch, commit }, { id, communityIds, communityServiceStatus }) {
      const url = '/api/community/open/bridgeapi/updateCommSvRelaStatus';
      const params = { id, communityIds, communityServiceStatus };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除我的服务  *
     *****************/
    DELETE_MY_SERVICE ({ dispatch, commit }, { id, communityIds }) {
      const url = '/api/community/open/bridgeapi/deleteCommunityService';
      const params = { id, communityIds, };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /*************************************************/

    //                    商家订单管理                    //

    /*************************************************/

    /*******************
     *  商家订单  *
     *******************/
    GET_FEE_OPEN_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, service_id, type, community_id, pay_status, id, merchant_name, service_name, order_no }) {
      const url = '/api/community/open/bridgeapi/fee_open_fee_order_list';
      const params = { index, size, service_id, type, community_id, pay_status, id, merchant_name, service_name, order_no };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  核销订单详情  *
     *******************/
    GET_ORDER_INFO ({ dispatch, commit }, { id }) {
      const url = '/api/community/open/bridgeapi/fee_get_open_fee_order_info';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    服务订单                    //

    /*************************************************/

    /*****************
     *  获取订单列表  *
     *****************/
    GET_MY_SERVICE_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, billStatus, merchantId, outTradeNo, cityId = null, communityIds = null,
      merchantName, serviceId, serviceName, startCreateTime, endCreateTime } = {}) {
      const url = '/api/community/open/bridgeapi/getOrderList';
      const params = {
        index, size, billStatus, merchantId, outTradeNo, cityId, communityIds,
        merchantName, serviceId, serviceName, startCreateTime, endCreateTime
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    财务管理                    //

    /*************************************************/

    /*********************
     *  获取资金汇总信息  *
     *********************/
    GET_SERVICE_FINANCE_TOTAL_INFO ({ dispatch, commit }, { cityId = null, communityIds = null } = {}) {
      const url = '/api/community/open/bridgeapi/listTotalOpenOrderFinance';
      const params = { cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取资金统计列表  *
     *********************/
    GET_SERVICE_FINANCE_LIST ({ dispatch, commit }, { index = 1, size = 10,
      stitle, mtitle, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/open/bridgeapi/listOpenOrderFinance';
      const params = { index, size, stitle, mtitle, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /*************************
     *  获取CBRE管家服务结算列表  *
     *************************/
    GET_SERVICE_CHARGE_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId, communityIds,
      title = '', set_id, pf_status, community_id, account_id, begin_create_time, end_create_time } = {}) {
      const url = '/api/community/open/bridgeapi/openSettCommunityList';
      const params = {
        index, size, cityId, communityIds,
        title, set_id, pf_status, community_id, account_id, begin_create_time, end_create_time
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /***********************************
     *  获取基础服务结算列表 - 历史数据  *
     ***********************************/
    GET_SETTLEMENT_APPLY_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      approveStatus, settleStatus, startCreateTime, endCreateTime } = {}) {
      const url = '/api/community/admin/getSettlementApplyList';
      const params = { index, size, cityId, communityIds, approveStatus, settleStatus, startCreateTime, endCreateTime };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************************
     *  获取基础服务结算列表 - 批量处理  *
     ***********************************/
    GET_SETTLEMENT_BATCH_APPLY_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      startCreateTime, endCreateTime, batchSettleStatus } = {}) {
      const url = '/api/community/admin/getBatchSettlementApplyList';
      const params = { index, size, cityId, communityIds, startCreateTime, endCreateTime, batchSettleStatus };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************************
     *  获取基础服务结算详情 - 历史数据  *
     ***********************************/
    GET_SETTLEMENT_DETAIL ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getSettlementApplyDetail';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取基础服务结算详情  *
     *************************/
    GET_SETTLEMENT_SUMMARY ({ dispatch, commit }, batchId) {
      const url = '/api/community/admin/getSettlementApplySummary';
      const params = { batchId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取结算起始日期  *
     *********************/
    GET_LATEST_SETTLEMENT_START_DATE ({ dispatch, commit }, communityIds) {
      const url = '/api/community/admin/getLastSettlementDate';
      const params = { communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取可结算社区列表  *
     ***********************/
    GET_SETTLEMENT_AVAILABLE_COMM_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getCommunityListWithSettleStatus';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  提交结算  *
     **************/
    APPLY_SETTLEMENT ({ dispatch, commit }, { endTime, communityIds }) {
      const url = '/api/community/admin/settlementApply';
      const params = { endTime, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    小富市集                    //

    /*************************************************/

    /***********************
     *  获取服务费明细列表  *
     ***********************/
    GET_PLATFORM_CHARGE_LIST ({ dispatch, commit }, { index = 1, size = 10, invoiceStatus, serviceName, startCreateTime, endCreateTime } = {}) {
      const url = '/api/community/admin/getServiceChargeList';
      const params = { index, size, invoiceStatus, serviceName, startCreateTime, endCreateTime };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  小富市集列表  *
     *****************/
    GET_RF_FAIR_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId, communityIds, signUpStatus } = {}) {
      const url = '/api/community/open/bridgeapi/listOpenXFSJInfo';
      const params = { index, size, cityId, communityIds, signUpStatus };

      return POST({ dispatch, commit }, url, params);
    },

    /**************************
     *  小富市集禁用和启用接口  *
     **************************/
    CHANGE_FAIR_STATUS ({ dispatch, commit }, { id, status, cityId, communityIds } = {}) {
      const url = '/api/community/open/bridgeapi/updateOpenXFSJInfoStatus';
      const params = { id, status, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /******************************
     *  小富市集报名禁用和启用接口  *
     ******************************/
    CHANGE_FAIR_SIGN_STATUS ({ dispatch, commit }, { id, status } = {}) {
      const url = '/api/community/open/bridgeapi/updateXFSJSignUpStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************************
     *  小富市集获取审批时的商家列表  *
     ********************************/
    GET_RF_FAIR_LIST_AUDIT ({ dispatch, commit }, { index = 1, size = 10, status, activityName } = {}) {
      const url = '/api/community/open/bridgeapi/listOpenXFSJSignUpAuditInfo';
      const params = { index, size, status, activityName };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  小富市集获取审批时的商家信息  *
     *****************/
    GET_RF_FAIR_BUSINESS_AUDIT_INFO ({ dispatch, commit }, { id, merchantId } = {}) {
      const url = '/api/community/open/bridgeapi/getOpenXFSJBusinessAuditInfo';
      const params = { id, merchantId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  小富市集审核接口  *
     *****************/
    RF_FAIR_AUDIT ({ dispatch, commit }, { id, status, statusContent = '', parameters = '' } = {}) {
      const url = '/api/community/open/bridgeapi/xfsj_audit';
      const params = { id, status, statusContent, parameters };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
      * 小富市集-招商信息-店铺列表  *
      *************************/
    SIGN_UP_LIST ({ dispatch, commit }, { id } = {}) {
      const url = '/api/community/open/bridgeapi/signUpList';
      const params = { id };
      return POST({ dispatch, commit }, url, params);
    },

    /*************************
      * 小富市集-集团主题配置新增
      *************************/
    INSERT_GROUP_CONFIG ({ dispatch, commit }, { name } = {}) {
      const url = '/api/community/open/bridgeapi/insert_group_config';
      const params = { name };
      return POST({ dispatch, commit }, url, params);
    },

    /*************************
      * 小富市集-集团主题配置修改
      *************************/
    UPDATE_GROUP_CONFIG ({ dispatch, commit }, { name, id } = {}) {
      const url = '/api/community/open/bridgeapi/update_group_config';
      const params = { name, id };
      return POST({ dispatch, commit }, url, params);
    },

    /*************************
      * 小富市集-集团主题配置列表
      *************************/
    LIST_GROUP_CONFIG ({ dispatch, commit }) {
      const url = '/api/community/open/bridgeapi/list_group_config';
      const params = {};
      return POST({ dispatch, commit }, url, params);
    },

    /*************************
      * 小富市集-地区主题配置列表
      *************************/
    LIST_AREA_CONFIG ({ dispatch, commit }, { city_id, group_config_id } = {}) {
      const url = '/api/community/open/bridgeapi/list_area_config';
      const params = { city_id, group_config_id };
      return POST({ dispatch, commit }, url, params);
    },

    /*************************
    * 小富市集-地区主题配置新增
    *************************/
    INSERT_AREA_CONFIG ({ dispatch, commit }, { name, city_id, group_config_id } = {}) {
      const url = '/api/community/open/bridgeapi/insert_area_config';
      const params = { name, city_id, group_config_id };
      return POST({ dispatch, commit }, url, params);
    },

    /*************************
    * 小富市集-地区主题配置修改
    *************************/
    UPDATE_AREA_CONFIG ({ dispatch, commit }, { name, id } = {}) {
      const url = '/api/community/open/bridgeapi/update_area_config';
      const params = { name, id };
      return POST({ dispatch, commit }, url, params);
    },

    /**********************************
     * 小富市集-招商信息-店铺列表-删除  *
     **********************************/
    DELETE_SIGN_UP_USER ({ dispatch, commit }, { id } = {}) {
      const url = '/api/community/open/bridgeapi/deleteSignUpUser';
      const params = { id };
      return POST({ dispatch, commit }, url, params);
    },

    /***********************************
     *  小富市集修改小富市集基本信息接口  *
     ************************************/
    MODIFY_FAIR ({ dispatch, commit }, { id, actTitile, actImg, actAddress, actTime, detail, cityId, communityIds } = {}) {
      const url = '/api/community/open/bridgeapi/updateOpenXFSJInfo';
      const params = { id, actTitile, actImg, actAddress, actTime, detail, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  小富市集添加活动接口  *
     *************************/
    ADD_FAIR ({ dispatch, commit }, { cityId, communityIds, actTitile, actImg, actTime, actAddress, detail, beginTime, endTime, signUpEndTime,
      amount, serviceFee, localeImg, type, contactPhone, localeDetail, groupConfigId, areaConfigId
    } = {}) {
      const url = '/api/community/open/bridgeapi/createOpenXFSJInfo';
      const params = {
        cityId, communityIds, actTitile, actImg, actTime, actAddress, detail, beginTime, endTime, signUpEndTime,
        amount, serviceFee, localeImg, type, contactPhone, localeDetail, groupConfigId, areaConfigId
      };
      return POST({ dispatch, commit }, url, params);
    },

    /***********************************
     *  获取商家审批列表接口(有3个版本)  *
     ***********************************/
    GET_MERCHANT_AUDIT_LIST ({ dispatch, commit }, { index = 1, size = 10, authName,
      merchant_name, src_business, merchant_type, src_city, audit_status } = {}) {
      const url = `/api/community/open/bridgeapi/listMerchantAuditInfo_${authName}`;
      const params = { index, size, merchant_name, src_business, merchant_type, src_city, audit_status };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  商家审批接口  *
     *****************/
    APPROVE_MERCHANT_ACTION ({ dispatch, commit }, { id, status, statusContent } = {}) {
      const url = '/api/community/open/bridgeapi/xfsj_merchantAudit';
      const params = { id, status, statusContent };

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  单个商家信息数据接口  *
     ************************/
    GET_MERCHANT_AUDIT_INFO ({ dispatch, commit }, { id, merchant_id } = {}) {
      const url = '/api/community/open/bridgeapi/getOpenXFSJAuditInfo';
      const params = { id, merchant_id };

      return POST({ dispatch, commit }, url, params);
    },

    /**************
     *  改派接口  *
     **************/
    MERCHANT_RESSIGN ({ dispatch, commit }, { merchant_id, srcBusiness, srcCity } = {}) {
      const url = '/api/community/open/bridgeapi/updateMerchantSrcBusiness';
      const params = { merchant_id, srcBusiness, srcCity };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  地区对应城市接口  *
     *********************/
    GET_ASSIGN_CITIES ({ dispatch, commit }) {
      const url = '/api/community/open/bridgeapi/city_by_community';

      return POST({ dispatch, commit }, url);
    },

    /*********************************
     *  社区资源管理-获取社区资源列表  *
     *********************************/
    GET_COMMUNITY_RESOURCE ({ dispatch, commit }) {
      const url = '/api/platform/open/bridgeapi/listCommunityResourceByCondition';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  小富市集详情信息查看  *
     *************************/
    GET_ACTIVETY ({ dispatch, commit }, { id, cityId, communityIds } = {}) {
      const url = '/api/community/open/bridgeapi/getOpenXFSJInfo';
      const params = { id, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  小富市集招商详情  *
     *************************/
    GET_ACTIVITY_BUSINESS_INFO ({ dispatch, commit }, { id } = {}) {
      const url = '/api/community/open/bridgeapi/getOpenXFSJBusinessInfo';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  小富市集生活馆带分页列表  *
     ****************************/
    GET_LIVE_PREFERCE_LIST ({ dispatch, commit }, { type, xfsjId } = {}) {
      const url = '/api/community/open/bridgeapi/listOpenXFSJStoreGood';
      const params = { type, xfsjId };

      return POST({ dispatch, commit }, url, params);
    },

    /************************************
     *  小富市集删除生活馆\优选馆商品接口  *
     ************************************/
    DELETE_LIVE_PREFERCE_GOOD ({ dispatch, commit }, { xfsjId, id } = {}) {
      const url = '/api/community/open/bridgeapi/deleteOpenXFSJStoreGood';
      const params = { id, xfsjId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  小富市集删除优选馆商铺  *
     ***************************/
    DELETE_PREFERCE_STORE ({ dispatch, commit }, { xfsjId, storeId } = {}) {
      const url = '/api/community/open/bridgeapi/deleteOpenXFSJStore';
      const params = { storeId, xfsjId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  小富市集详获取链接地址  *
     ***************************/
    GET_FAIRURL ({ dispatch, commit }, { id, cityId, communityIds } = {}) {
      const url = '/api/community/open/bridgeapi/getOpenXFSJInfoStatus';
      const params = { id, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /**************************************************
     *  小富市集根据社区和服务名称查询服务列表带分页接口  *
     **************************************************/
    GET_STORES ({ dispatch, commit }, { title, index = 1, size = 10, cityId, communityIds } = {}) {
      const url = '/api/community/open/bridgeapi/listStoreName';
      const params = { title, index, size, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /***************************************
     *  小富市集根据服务商查询商品带分页接口  *
     ***************************************/
    GET_GOODS ({ dispatch, commit }, { title = '', index = 1, size = 10, storeId } = {}) {
      const url = '/api/community/open/bridgeapi/listStoreGood';
      const params = { title, index, size, storeId };

      return POST({ dispatch, commit }, url, params);
    },

    /***************************************
     *  小富市集增加生活馆 / 优选馆商品接口  *
     ***************************************/
    ADD_GOODS ({ dispatch, commit }, { xfsjId, goodId, type, storeId, img, title } = {}) {
      const url = '/api/community/open/bridgeapi/createOpenXFSJStoreGood';
      const params = { xfsjId, goodId, type, storeId, img, title };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /*********************
     *  获取市集商家列表  *
     *********************/
    GET_FAIR_MERCHANT_LIST ({ dispatch, commit }, { index = 1, size = 10, category_second_type, service_title, merchant_title } = {}) {
      const url = '/api/community/open/bridgeapi/listBusinessManagerAdmin';
      const params = { index, size, category_second_type, service_title, merchant_title };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取市集商家详情  *
     *********************/
    GET_FAIR_MERCHANT_DETAIL ({ dispatch, commit }, id) {
      const url = '/api/community/open/bridgeapi/getBusinessManagerAdmin';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改店铺分类  *
     *****************/
    EDIT_FAIR_STORE_CATEGORY ({ dispatch, commit }, { id, categorySecondType } = {}) {
      const url = '/api/community/open/bridgeapi/updateServiceByCategorySecondType';
      const params = { id, categorySecondType };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  修改社区服务费  *
     *******************/
    EDIT_FAIR_STORE_COMM_FEE ({ dispatch, commit }, { id, communityFee } = {}) {
      const url = '/api/community/open/bridgeapi/updateServiceByCommunityFee';
      const params = { id, communityFee };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改商品溢价幅度  *
     *********************/
    EDIT_FAIR_STORE_PREMIUM_NUM ({ dispatch, commit }, { id, premiumNum } = {}) {
      const url = '/api/community/open/bridgeapi/updateServiceByPremiumNum';
      const params = { id, premiumNum };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  更改商店状态  *
     *****************/
    UPDATE_FAIR_STORE_STATUS ({ dispatch, commit }, { id, status } = {}) {
      const url = '/api/community/open/bridgeapi/updateServiceByStatus';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取店铺类型列表  *
     *********************/
    GET_FAIR_MERCHANT_CATEGORY_LIST ({ dispatch, commit }, { index = 1, size = 999 } = {}) {
      const url = '/api/community/open/bridgeapi/listCommunityServiceCategory';
      const params = { index, size };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加店铺类型  *
     *****************/
    CREATE_FAIR_MERCHANT_CATEGORY ({ dispatch, commit }, { name, sort, premiumNum, communityFee } = {}) {
      const url = '/api/community/open/bridgeapi/addCommunityServiceCategory';
      const params = { name, sort, type: 3, premiumNum, communityFee };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  编辑店铺类型  *
     *****************/
    EDIT_FAIR_MERCHANT_CATEGORY ({ dispatch, commit }, { id, name, sort, premiumNum, communityFee } = {}) {
      const url = '/api/community/open/bridgeapi/updateCommunityServiceCategory';
      const params = { id, name, sort, type: 3, premiumNum, communityFee };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除店铺类型  *
     *****************/
    DELETE_FAIR_MERCHANT_CATEGORY ({ dispatch, commit }, id) {
      const url = '/api/community/open/bridgeapi/deleteCommunityServiceCategory';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取保证金缴纳详情  *
     ***********************/
    GET_CAUTION_MONEY_DETAIL ({ dispatch, commit }, serviceId) {
      const url = '/api/community/open/bridgeapi/listOpenCautionInfo';
      const params = { serviceId };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  增加保证金  *
     ****************/
    ADD_CAUTION_MONEY ({ dispatch, commit }, { serviceId, money, remarks } = {}) {
      const url = '/api/community/open/bridgeapi/addOpenCautionInfo';
      const params = { serviceId, money, remarks };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************
     *  修改保证金缴纳状态  *
     **********************/
    SET_CAUTION_MONEY_PAY_STATUS ({ dispatch, commit }, { id, status } = {}) {
      const url = '/api/community/open/bridgeapi/statusOpenCautionInfo';
      const params = { id, status };

      return POST({ dispatch, commit }, url, params);
    },

    /****************
     *  退还保证金  *
     ****************/
    CONFIRM_CAUTION_MONEY_REFUND ({ dispatch, commit }, { serviceId, caution_refund_reason } = {}) {
      const url = '/api/community/open/bridgeapi/cautionRefundReason';
      const params = { serviceId, caution_refund_reason };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /************************
     *  小富市集 - 巡查情况  *
     ************************/
    GET_PATROL_INFO ({ dispatch, commit }, { xfsjId } = {}) {
      const url = '/api/community/open/bridgeapi/getPatrolInfo';
      const params = { xfsjId };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************************
     *  小富市集 - 获取督察者项目关联状态接口  *
     ****************************************/
    GET_SUPERVISION_DETAIL ({ dispatch, commit }, { empMobile, type } = {}) {
      const url = '/api/community/guanjia/bridgeapi/getInspectorProjectList';
      const params = { empMobile, type };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************************
     *  小富市集 - 获取督察者接口  *
     *****************************/
    GET_SUPERVISION_PERSON_DETAIL ({ dispatch, commit }, { mobile } = {}) {
      const url = '/api/community/guanjia/bridgeapi/getEmpInfo';
      const params = { mobile };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************************
     *  小富市集 - 添加督察者接口  *
     *****************************/
    ADD_SUPERVISION ({ dispatch, commit }, { empMobile, communityIds, type } = {}) {
      const url = '/api/community/guanjia/bridgeapi/inspectorAdd';
      const params = { empMobile, communityIds, type };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************************
     *  小富市集 - 修改督察者项目关联状态接口  *
     ****************************************/
    EIDT_SUPERVISION_DETAIL ({ dispatch, commit }, { empMobile, communityIds, type, desc, empGuid } = {}) {
      const url = '/api/community/guanjia/bridgeapi/inspectorEdit';
      const params = { empMobile, communityIds, type, desc, empGuid };

      return POST({ dispatch, commit }, url, params);
    },

    /**************************************
     *  小富市集-删除督察者项目关联状态接口  *
     **************************************/
    DELETE_SUPERVISION_DETAIL ({ dispatch, commit }, { id, desc, empGuid } = {}) {
      const url = '/api/community/guanjia/bridgeapi/inspectorDel';
      const params = { id, desc, empGuid };

      return POST({ dispatch, commit }, url, params);
    },

    /***************************
     *  小富市集-综合服务费订单  *
     ***************************/
    GENERAL_ORDER_LIST ({ dispatch, commit }, { cityId, communityIds, bill_status, create_time_begin, create_time_end,
      merchant_title, service_title, act_titile, bill_id, index = 1, size = 10 } = {}) {
      const url = '/api/community/open/bridgeapi/generalServiceOrder';
      const params = {
        cityId, communityIds, bill_status, create_time_begin, create_time_end,
        merchant_title, service_title, act_titile, bill_id, index, size
      };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************************
     *  小富市集 - 服务运营者及巡查者列表接口  *
     ****************************************/
    GET_SUPERVISION_LIST ({ dispatch, commit }, { cityCode = '', communityIds = '', type = '', empName = '',
      empMobile = '', pageSize = 10, startRow = 0 } = {}) {
      const url = '/api/community/guanjia/bridgeapi/getInspectorList';
      const params = {
        cityCode, communityIds, type, empName,
        empMobile, pageSize, startRow
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                   停车场管理                   //

    /*************************************************/

    /*****************
     *  查询该社区关联的车场  *
     *****************/
    QUERY_PARKING_CONF_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/queryParkingConfList';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取订单列表  *
     *****************/
    GET_PARKING_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      orderType, id, serialNo, carPlateNo, cardNo, mobile, payStatus, startDate, endDate, paySrc, userName, parkingCodeId } = {}) {
      const url = '/api/community/admin/getParkingOrderList';
      const params = {
        index, size, cityId, communityIds, orderType, id, serialNo, carPlateNo, cardNo,
        mobile, payStatus, startDate, endDate, paySrc, userName, parkingCodeId
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除无牌车记录  *
     *****************/
    DELETE_PARKING_UNPAID_RECORD ({ dispatch, commit }, params) {
      const url = 'api/community/admin/clearParkingQrcoceIn';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取线下订单列表  *
     *****************/
    GET_PARKING_PAYMENT_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getParkingPaymentOrderList';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取线下订单详情  *
     *****************/
    GET_PARKING_PAYMENT_DETAIL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getParkingPaymentOrderDetail';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取订单详情  *
     *****************/
    GET_PARKING_ORDER_DETAIL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getParkingOrderDetail';

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取-发票相关提示信息  *
    *****************/
    GET_MESSAGE_TIPS ({ dispatch, commit }, { type = 1, communityId } = {}) {
      const url = '/api/community/admin/getMessageTips';
      const params = { type, communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  更新-发票相关提示信息  *
     *****************/
    UPDATE_MESSAGE_TIPS ({ dispatch, commit }, { tipsId, msgTips } = {}) {
      const url = '/api/community/admin/updateMessageTips';
      const params = { tipsId, msgTips };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  更新-发票相关提示信息 id为0时 *
     *****************/
    ADD_MESSAGE_TIPS ({ dispatch, commit }, { type = 1, communityId, msgName = '月保费发票领取 ', msgTips } = {}) {
      const url = '/api/community/admin/addMessageTips';
      const params = { type, communityId, msgName, msgTips };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  获取停车场列表  *
     *******************/
    GET_PARKING_CONF_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getParkingConfList';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_PARKING_CONF_LIST', data);
        return Promise.resolve(data);
      }).catch((error) => {
        commit('SET_PARKING_CONF_LIST', []);
        return Promise.reject(error);
      });
    },

    /*****************
     *  获取流水总计  *
     *****************/
    GET_PARKING_REPORT_SUM ({ dispatch, commit }, { cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getParkingReportSum';
      const params = { cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取流水列表  *
     *****************/
    GET_PARKING_REPORT_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null, queryType } = {}) {
      const url = '/api/community/admin/getParkingReportDetail';
      const params = { index, size, cityId, communityIds, queryType };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  查询该社区关联的车场  *
     *****************/
    QUERY_PARKING_CONF_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/queryParkingConfList';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取批量上传图片处理结果  *
     *****************/
    GET_PRICE_UPLOAD_RECORD ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getUploadRecords';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取车位占用实时数据  *
     *****************/
    GET_PARKING_REAL_TIME_REPORT ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getParkingRealTimeReport';
      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /*********************
     *  获取车场商家列表  *
     *********************/
    GET_PARKING_COUPON_MERCHANT_LIST ({ dispatch, commit }, { index = 1, size = 10, shopperName, status } = {}) {
      const url = '/api/community/admin/getParkingCouponShopperList';
      const params = { index, size, shopperName, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改车场商家授权  *
     *********************/
    CHANGE_PARKING_COUPON_MERCHANT_STATUS ({ dispatch, commit }, { ids, status } = {}) {
      const url = '/api/community/admin/parkingCouponStateSet';
      const params = { ids, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  新增或修改商家  *
     *********************/
    MODIFY_PARKING_COUPON_SHOPPER ({ dispatch, commit }, params) {
      const url = 'api/community/admin/addOrUpdateParkingCouponShopper';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  查询商家详情  *
     *********************/
    GET_PARKING_COUPON_SHOPPER_DETAIL ({ dispatch, commit }, params) {
      const url = 'api/community/admin/getParkingCouponShopperDetailById';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  查询商家的商家券列表  *
     *********************/
    GET_PARKING_COUPON_SHOPPER_LIST ({ dispatch, commit }, params) {
      const url = 'api/community/admin/getParkingCouponShopperTicketList';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取商家可选择的商家券列表  *
     *********************/
    GET_CHOOSE_COUPON_LIST ({ dispatch, commit }, params) {
      const url = 'api/community/admin/getParkingCouponShopperCanChooseTicketList';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改商家可选择的商家券列表  *
     *********************/
    MODIFY_CHOOSE_COUPON_LIST ({ dispatch, commit }, params) {
      const url = 'api/community/admin/updateParkingCouponShopperTicketList';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取商家的全局商家券配置  *
     *********************/
    GET_GLOBAL_TICKET_CONFIG ({ dispatch, commit }, params) {
      const url = 'api/community/admin/getParkingCouponShopperGlobalTicketConfig';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改商家的全局商家券配置  *
     *********************/
    MODIFY_GLOBAL_TICKET_CONFIG ({ dispatch, commit }, params) {
      const url = 'api/community/admin/updateParkingCouponShopperGlobalTicketConfig';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取某个商家的商家券配置  *
     *********************/
    GET_SHOPPER_TICKET_CONFIG ({ dispatch, commit }, params) {
      const url = 'api/community/admin/getParkingCouponShopperTicketConfig';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改某个商家的商家券配置  *
     *********************/
    MODIFY_SHOPPER_TICKET_CONFIG ({ dispatch, commit }, params) {
      const url = 'api/community/admin/updateParkingCouponShopperTicketConfig';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取停车场商家券统计报告汇总  *
     *********************/
    GET_COUPON_REPORT_SUM ({ dispatch, commit }, params) {
      const url = 'api/community/admin/getParkingCouponTicketReportSum';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取停车场商家券统计报告明细（日，周，月，年）  *
     *********************/
    GET_COUPON_REPORT_DETAIL ({ dispatch, commit }, params) {
      const url = 'api/community/admin/getParkingCouponTicketReportDetail';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取社区车场价目表列表  *
     *********************/
    GET_PRICE_TABLE_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getParkingBaseList';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  变更停车场配置图片  *
     *********************/
    MODIFY_PRICE_TABLE_PICTURE ({ dispatch, commit }, params) {
      const url = '/api/community/admin/modifyParkingPriceImg';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取车场开关控制状态  *
     *********************/
    GET_PARKING_BASE_CONTROL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getParkingBaseControlExtra';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  停车场配置平台配置  *
     *********************/
    MODIFY_PARKING_BASE_CONTROL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/modifyParkingBaseControl';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  停车场配置项目配置  *
     *********************/
    MODIFY_PARKING_LITE_CONTROL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/modifyParkingLiteControl';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改商家固定车位数  *
     *********************/
    MODIFY_PARKING_COUPON_MERCHANT_FIXED_CARPORT ({ dispatch, commit }, params) {
      const url = '/api/community/admin/modifyShopper';
      // const params = { ids, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  获取商家券列表  *
     *******************/
    GET_PARKING_COUPON_LIST ({ dispatch, commit }, { index = 1, size = 10, couponName, status, balanceType, validateType } = {}) {
      const url = '/api/community/admin/getParkingCouponTicketList';
      const params = { index, size, couponName, status, balanceType, validateType };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  新增商家券  *
     *******************/
    MODIFY_PARKING_COUPON_ITEM ({ dispatch, commit }, params) {
      const url = 'api/community/admin/addOrUpdateParkingCouponTicket';
      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  发券开关  *
     *******************/
    MODIFY_SEND_CHECK ({ dispatch, commit }, params) {
      const url = '/api/community/admin/modifySendCheck';
      // const params = { index, size, couponName, status, balanceType, validateType };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  获取商家卡券列表带配置  *
     *******************/
    GET_SHOPPER_COUPONS ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getShopperCoupons';
      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  卡券手动派发  *
     *******************/
    DISPATCH_COUPON_MANUAL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/orderCouponHandSpec';
      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  新增卡券配置信息  *
     *******************/
    ENABLE_AUTO_DISPATCH_COUPON ({ dispatch, commit }, params) {
      const url = '/api/community/admin/addCouponSchedule';
      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  禁用卡券配置信息  *
     *******************/
    DISABLE_AUTO_DISPATCH_COUPON ({ dispatch, commit }, params) {
      const url = '/api/community/admin/disableCouponSchedule';
      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  单独获取卡券配置信息  *
     *******************/
    GET_AUTO_DISPATCH_COUPON_CONFIG ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getCouponSchedule';
      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  获取商家券适用停车场列表  *
     ****************************/
    GET_PARKING_COUPON_PARK_LIST ({ dispatch, commit }, ticketId) {
      const url = '/api/community/admin/getParkingCouponTicketParkList';
      const params = { ticketId };

      return POST({ dispatch, commit }, url, params);
    },

    /*******************
     *  获取券订单列表  *
     *******************/
    GET_PARKING_COUPON_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, couponCode,
      shopperName, userPhone, couponType, startDate, endDate } = {}) {
      const url = '/api/community/admin/getCouponBuyOrderList';
      const params = { index, size, couponCode, shopperName, userPhone, couponType, startDate, endDate };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取零元券订单列表  *
     ***********************/
    GET_FREE_PARKING_COUPON_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10, couponCode,
      shopperName, userPhone, couponType, startDate, endDate } = {}) {
      const url = '/api/community/admin/getCouponFreeOrderList';
      const params = { index, size, couponCode, shopperName, userPhone, couponType, startDate, endDate };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取月保审批列表   *
     ***********************/
    GET_MONTH_AUDIT_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getMonthAuditList';
      return POST({ dispatch, commit }, url, params);
    },

    /*****************************
     * 修改月保审批数据状态接口  *
     *****************************/
    MODIFY_MONTH_AUDIT_STATUS ({ dispatch, commit }, params) {
      const url = '/api/community/admin/modifyMonthAuditStatus';
      return POST({ dispatch, commit }, url, params);
    },

    /************************
     * 修改月保审批配置列表  *
     *************************/
    GET_MONTH_AUDIT_CONFIG ({ dispatch, commit }, { status } = {}) {
      const url = '/api/community/admin/getMonthAuditConfig';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     * 修改月保审批配置开关  *
     *************************/
    GET_MONTH_AUDIT_CONFIG_Status ({ dispatch, commit }, { configId, status } = {}) {
      const url = '/api/community/admin/modifyMonthAuditConfigStatus';
      const params = { configId, status };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取发券记录列表  *
     *********************/
    GET_PARKING_COUPON_SEND_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      shopperName, userPhone, couponType, startDate, endDate, carPlateNo } = {}) {
      const url = '/api/community/admin/getTicketSendTicketList';
      const params = { index, size, cityId, communityIds, shopperName, userPhone, couponType, startDate, endDate, carPlateNo };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取固定无牌车列表  *
     *********************/
    GET_UNLICENSED_CAR_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/parking/getFixedRecordList';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改固定无牌车状态  *
     *********************/
    MODIFY_UNLICENSED_CAR_STATUS ({ dispatch, commit }, params) {
      const url = '/api/community/admin/parking/modifyRecordStauts';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取固定无牌车详情  *
     *********************/
    GET_UNLICENSED_CAR_DETAIL ({ dispatch, commit }, params) {
      const url = '/api/community/admin/parking/getFixRecordDetail';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  编辑固定无牌车记录  *
     *********************/
    MODIFY_UNLICENSED_CAR_RECORD ({ dispatch, commit }, params) {
      const url = '/api/community/admin/parking/editFixedCar';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  新增固定无牌车记录  *
     *********************/
    ADD_UNLICENSED_CAR_RECORD ({ dispatch, commit }, params) {
      const url = '/api/community/admin/parking/addFixedCar';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取充电桩购卡列表  *
     *********************/
    GET_CARD_RECORD_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/parking/charge/getCardRecordList';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取用电订单列表  *
     *********************/
    GET_CHARGE_RECORD_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/parking/charge/getChargeRecordList';
      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /***************************
     *  获取 POMP 授权用户列表  *
     ***************************/
    GET_POMP_USER_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      status, accessPhone, accessName } = {}) {
      const url = '/api/community/admin/getPOMPUserList';
      const params = { index, size, cityId, communityIds, status, accessPhone, accessName };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  修改 POMP 用户授权  *
     ***********************/
    EDIT_POMP_USER ({ dispatch, commit }, { accessUserId, status } = {}) {
      const url = '/api/community/admin/editUserPOMPPrivilege';
      const params = { accessUserId, status };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  检查POMP中根据手机搜索  *
     ***********************/
    QUERY_USER_ACCESS_REGIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/queryUserAccessRegist';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  增加POMP访问用户  *
     ***********************/
    ADD_COUPON_ACCESS_USER ({ dispatch, commit }, params) {
      const url = '/api/community/admin/addCouponAccessUser';
      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //              业务办理（门禁卡办理）              //

    /*************************************************/

    /*****************
     *  获取订单列表  *
     *****************/
    GET_BIZ_APPLY_ORDER_LIST ({ dispatch, commit }, { index = 1, size = 10,
      areaId, tradeNo, masterId, startApplyTime, endApplyTime, orderStatus, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getBizApplyOrderList';
      const params = { index, size, areaId, tradeNo, masterId, startApplyTime, endApplyTime, orderStatus, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取业务配置  *
     *****************/
    GET_BIZ_CONF ({ dispatch, commit }, communityId) {
      const url = '/api/community/admin/getBizApplyConf';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  设置取卡地址  *
     *****************/
    SET_OBTAIN_ADDRESS ({ dispatch, commit }, { communityId, obtainAddress }) {
      const url = '/api/community/admin/setObtainAddress';
      const params = { communityId, obtainAddress };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  设置制卡费用  *
     *****************/
    SET_CARD_PRICE ({ dispatch, commit }, { communityId, cardPrice }) {
      const url = '/api/community/admin/setCardPrice';
      const params = { communityId, cardPrice };

      return POST({ dispatch, commit }, url, params);
    },

    /***************
     *  验证核销码  *
     ***************/
    VALIDATE_CARD_CODE ({ dispatch, commit }, vcode) {
      const url = '/api/community/admin/validateCode';
      const params = { vcode };

      return POST({ dispatch, commit }, url, params);
    },

    /**************************
     *  根据核销码获取订单信息  *
     **************************/
    GET_BIZ_APPLY_ORDER_BY_CODE ({ dispatch, commit }, vcode) {
      const url = '/api/community/admin/getBizApplyOrderByValidateCode';
      const params = { vcode };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    积分管理                    //

    /*************************************************/

    /************************
     *  获取用户积分行为列表  *
     ************************/
    GET_MY_BONUS_POINT_ACTION_DETAIL_LIST ({ dispatch, commit }, { index = 1, size = 10, actionTypeId, rewardRule }) {
      const url = '/api/community/admin/platform/getBonusPointActionRuleList';
      const params = { index, size, actionTypeId, rewardRule };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改积分行为  *
     *****************/
    EDIT_BONUS_POINT_ACTION_RULE ({ dispatch, commit }, { action, rewardValue, rewardRule,
      bpRule, bpValue, bpRuleDesc, startActiveTime } = {}) {
      const url = '/api/community/admin/platform/editBonusPointActionRule';
      const params = { action, rewardValue, rewardRule, bpRule, bpValue, bpRuleDesc, startActiveTime };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改积分描述  *
     *****************/
    EDIT_BONUS_POINT_ACTION_DETAIL ({ dispatch, commit }, { actionId, action, actionName, actionTypeId, actionDesc,
      sequenceId, png, isShowInApp, project } = {}) {
      const url = '/api/community/admin/editBonusPointAction';
      const params = {
        actionId, action, actionName, actionTypeId, actionDesc,
        sequenceId, png, isShowInApp, project
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /*********************
     *  获取积分发放列表  *
     *********************/
    GET_BONUS_POINT_GRANT_LIST ({ dispatch, commit }, { index = 1, size = 10, isMasterUser,
      phone, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getUserGrantList';
      const params = { index, size, isMasterUser, phone, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取积分发放统计  *
     *********************/
    GET_BONUS_POINT_GRANT_STAT ({ dispatch, commit }) {
      const url = '/api/community/admin/getUserGrantStat';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /*********************
     *  获取积分兑换列表  *
     *********************/
    GET_BONUS_POINT_EXCHANGE_LIST ({ dispatch, commit }, { index = 1, size = 10,
      subjectType, startExchangeTime, endExchangeTime } = {}) {
      const url = '/api/community/admin/platform/getBonusPointExchangeList';
      const params = { index, size, subjectType, startExchangeTime, endExchangeTime };

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取已兑换奖品数量  *
     ***********************/
    GET_BONUS_POINT_EXCHANGE_CARD_COUNT ({ dispatch, commit }) {
      const url = '/api/community/admin/platform/getBonusPointExchangeEcardCount';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取积分滚动清零配置  *
     ***********************/
    GET_BONUS_POINT_ZERO_CLEAR_CONFIG ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getBonusPointZeroClearConfig';
      return POST({ dispatch, commit }, url, params);
    },
    /***********************
     *  保存积分滚动清零配置  *
     ***********************/
    SAVE_BONUS_POINT_ZERO_CLEAR_CONFIG ({ dispatch, commit }, params) {
      const url = '/api/community/admin/saveBonusPointZeroClearConfig';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取积分行为选项列表  *
     ***********************/
    GET_BONUS_POINT_ACTION__LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getAllBonusPointAction';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  分页获取积分行为异常监控列表  *
     ***********************/
    GET_BONUS_POINT_ACTION_EXCEPTION_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getBonusPointActionExceptionMonitorListByPage';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  批量加入虚拟值黑名单  *
     ***********************/
    ADD_USER_VIRTUAL_VALUE_BLACKLIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/batchAddUserVirtualValueBlacklist';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  分页获取虚拟值黑名单列表  *
     ***********************/
    GET_USER_VIRTUAL_VALUE_BLACKLIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getUserVirtualValueBlacklistByPage';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  用户积分清零  *
     ***********************/
    CLEAR_BONUS_POINT ({ dispatch, commit }, params) {
      const url = '/api/community/admin/bonusPointZeroClear';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  批量移除虚拟值黑名单  *
     ***********************/
    REMOVE_USER_VIRTUAL_VALUE_BLACKLIST ({ dispatch, commit }, params) {
      const url = '/api/community/admin/batchDeleteUserVirtualValueBlacklist';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取物业缴费积分行为费项配置  *
     ***********************/
    GET_ACTION_FEE_PROJECT_CONFIG ({ dispatch, commit }, params) {
      const url = '/api/community/admin/getPaymentBonusPointActionFeeProjectConfig';
      return POST({ dispatch, commit }, url, params);
    },

    /***********************
     *  获取物业缴费积分行为费项配置  *
     ***********************/
    SAVE_ACTION_FEE_PROJECT_CONFIG ({ dispatch, commit }, params) {
      const url = '/api/community/admin/savePaymentBonusPointActionFeeProjectConfig';
      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    收楼管理                    //

    /*************************************************/

    /************************
     *  获取收楼时间记录列表  *
     ************************/
    GET_REPOSSESSION_RECORD_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      loudong, floor, room, startTime, endTime, deliverStatus } = {}) {
      const url = '/api/community/admin/getRepossessionInfoList';
      const params = { index, size, cityId, communityIds, loudong, floor, room, startTime, endTime, deliverStatus };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  添加收楼时间记录  *
     *********************/
    CREATE_REPOSSESSION_RECORD ({ dispatch, commit }, { masterId, appointmentTime, appointmentEndTime }) {
      const url = '/api/community/admin/addRepossessionInfo';
      const params = { masterId, appointmentTime, appointmentEndTime };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改收楼时间记录  *
     *********************/
    EDIT_REPOSSESSION_RECORD ({ dispatch, commit }, { infoId, appointmentTime, appointmentEndTime }) {
      const url = '/api/community/admin/editRepossessionInfo';
      const params = { infoId, appointmentTime, appointmentEndTime };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /************************
     *  获取收楼文件配置列表  *
     ************************/
    GET_REPOSSESSION_CONFIG_LIST ({ dispatch, commit }, { index = 1, size = 10, cityId = null, communityIds = null,
      stepId, stepStatus } = {}) {
      const url = '/api/community/admin/getRepossessionCommunityStepList';
      const params = { index, size, cityId, communityIds, stepId, stepStatus };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取收楼步骤列表  *
     *********************/
    GET_REPOSSESSION_STEP_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getRepossessionStepList';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  获取收楼文件配置内容  *
     ************************/
    GET_REPOSSESSION_CONFIG_CONTENT ({ dispatch, commit }, communityStepId) {
      const url = '/api/community/admin/getRepossessionCommunityStepFileList';
      const params = { communityStepId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改收楼文件配置  *
     *********************/
    EDIT_REPOSSESSION_CONFIG ({ dispatch, commit }, { communityStepId, data }) {
      const url = '/api/community/admin/setRepossessionCommunityStepFileConf';
      const params = { communityStepId, data };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改收楼配置状态  *
     *********************/
    UPDATE_REPOSSESSION_CONFIG_STATUS ({ dispatch, commit }, { communityStepId, stepStatus }) {
      const url = '/api/community/admin/setRepossessionCommunityStepConf';
      const params = { communityStepId, stepStatus };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /************************
     *  获取收楼文件管理列表  *
     ************************/
    GET_REPOSSESSION_FILE_LIST ({ dispatch, commit }, { index = 1, size = 10, name, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getRepossessionFileList';
      const params = { index, size, name, cityId, communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  编辑收楼文件管理列表  *
     ************************/
    EDIT_REPOSSESSION_FILE ({ dispatch, commit }, { id, communityId, name } = {}) {
      const url = '/api/community/admin/editRepossessionFile';
      const params = { id, communityId, name };

      return POST({ dispatch, commit }, url, params);
    },

    /************************
     *  删除收楼文件管理列表  *
     ************************/
    DELETE_REPOSSESSION_FILE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteRepossessionFile';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    /*********************
     *  获取房间资料列表  *
     *********************/
    GET_ROOM_INFO_LIST ({ dispatch, commit }, { index = 1, size = 10, loudong, floor, room, propAddr, bindStatus,
      status, type, deliverStatus, hasCert, cityId = null, communityIds = null } = {}) {
      const url = '/api/community/admin/getRoomInfoList';
      const params = {
        index, size, loudong, floor, room, propAddr, bindStatus,
        status, type, deliverStatus, hasCert, cityId, communityIds
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取房间资料查验列表  *
     *************************/
    GET_REPOSSESSION_CHECK_LIST ({ dispatch, commit }, masterId) {
      const url = '/api/community/admin/getRepossessionCheck';
      const params = { masterId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  获取房间文件签收列表  *
     *************************/
    GET_REPOSSESSION_SIGNED_LIST ({ dispatch, commit }, masterId) {
      const url = '/api/community/admin/getRepossessionSigned';
      const params = { masterId };

      return POST({ dispatch, commit }, url, params);
    },

    // /*************************
    //  *  获取房间物业缴费信息  *
    //  *************************/
    // GET_REPOSSESSION_PAYMENT_INFO ({ dispatch, commit }, masterId) {
    //   const url = '/api/community/admin/getRepossessionPayment';
    //   const params = { masterId };

    //   return POST({ dispatch, commit }, url, params);
    // },

    /*************************
     *  获取房间现场查验信息  *
     *************************/
    GET_REPOSSESSION_ACCEPTANCE ({ dispatch, commit }, masterId) {
      const url = '/api/community/admin/getRepossessionAcceptance';
      const params = { masterId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  搜索物业缴费地址  *
     *********************/
    FIND_BIND_PROP_ADDR ({ dispatch, commit }, { communityId, buildName, floorName, roomName }) {
      const url = '/api/community/admin/queryBindPay';
      const params = { communityId, buildName, floorName, roomName };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  绑定物业缴费地址  *
     *********************/
    BIND_PROP_ADDR ({ dispatch, commit }, { masterId, communityId, areaName, buildName, unitName, floorName, roomName, houseType }) {
      const url = '/api/community/admin/bindPayAddress';
      const params = { masterId, communityId, areaName, buildName, unitName, floorName, roomName, houseType };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************
     *  解除物业缴费地址绑定  *
     *************************/
    UNBIND_PROP_ADDR ({ dispatch, commit }, bindId) {
      const url = '/api/community/admin/unbindPropAddrRoom';
      const params = { bindId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    活动管理                    //

    /*************************************************/

    /*****************
     *  获取活动列表  *
     *****************/
    GET_ACTIVITY_LIST ({ dispatch, commit }, { index = 1, size = 10, name = '', type = '',
      startTime1 = '', endTime1 = '', startTime2 = '', endTime2 = '' } = {}) {
      const url = '/api/community/admin/getActivityList';
      const params = { index, size, name, type, startTime1, endTime1, startTime2, endTime2 };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取活动信息  *
     *****************/
    GET_ACTIVITY ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getActivity';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加活动信息  *
     *****************/
    CREATE_ACTIVITY ({ dispatch, commit }, { name, type, startTime, endTime, targetCommunityIds,
      maxLotteryCount, maxLotteryCountPerDay, maxWinRealCount, maxWinEleCount, firstWinRequiredCount,
      firstWinPrizeType, msgUrl, msgTitle, msgContent, pushContent } = {}) {
      const url = '/api/community/admin/addActivity';
      const params = {
        name, type, startTime, endTime, targetCommunityIds,
        maxLotteryCount, maxLotteryCountPerDay, maxWinRealCount, maxWinEleCount, firstWinRequiredCount,
        firstWinPrizeType, msgUrl, msgTitle, msgContent, pushContent
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改活动信息  *
     *****************/
    EDIT_ACTIVITY ({ dispatch, commit }, { id, name, type, startTime, endTime, targetCommunityIds,
      maxLotteryCount, maxLotteryCountPerDay, maxWinRealCount, maxWinEleCount, firstWinRequiredCount,
      firstWinPrizeType, msgUrl, msgTitle, msgContent, pushContent } = {}) {
      const url = '/api/community/admin/editActivity';
      const params = {
        id, name, type, startTime, endTime, targetCommunityIds,
        maxLotteryCount, maxLotteryCountPerDay, maxWinRealCount, maxWinEleCount, firstWinRequiredCount,
        firstWinPrizeType, msgUrl, msgTitle, msgContent, pushContent
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除活动信息  *
     *****************/
    DELETE_ACTIVITY ({ dispatch, commit }, id) {
      const url = '/api/community/admin/deleteActivity';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /************************************************************************************/

    /*****************
     *  获取奖品列表  *
     *****************/
    GET_ACTIVITY_PRIZE_LIST ({ dispatch, commit }, { index = 1, size = 10, name, type, activityId } = {}) {
      const url = '/api/community/admin/getActivityPrizeList';
      const params = { index, size, name, type, activityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取奖品信息  *
     *****************/
    GET_ACTIVITY_PRIZE ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getActivityPrize';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加奖品信息  *
     *****************/
    CREATE_ACTIVITY_PRIZE ({ dispatch, commit }, { name, type, imagePath, eleValue, scoreValue, totalCount,
      activityId, cost, openTime, smsContent, weight, packageType } = {}) {
      const url = '/api/community/admin/addActivityPrize';
      const params = {
        name, type, imagePath, eleValue, scoreValue, totalCount,
        activityId, cost, openTime, smsContent, weight, packageType
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改奖品信息  *
     *****************/
    EDIT_ACTIVITY_PRIZE ({ dispatch, commit }, { id, code, name, type, imagePath, eleValue, scoreValue, totalCount,
      activityId, cost, openTime, smsContent, weight, packageType } = {}) {
      const url = '/api/community/admin/editActivityPrize';
      const params = {
        id, code, name, type, imagePath, eleValue, scoreValue, totalCount,
        activityId, cost, openTime, smsContent, weight, packageType
      };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除奖品信息  *
     *****************/
    DELETE_ACTIVITY_PRIZE ({ dispatch, commit }, { id, code }) {
      const url = '/api/community/admin/deleteActivityPrize';
      const params = { id, code };

      return POST({ dispatch, commit }, url, params);
    },

    GET_CONFIRM_DATA ({ dispatch, commit }, { confirmCode }) {
      const url = '/api/community/admin/voucher/getConfirmData';
      const params = { confirmCode };

      return POST({ dispatch, commit }, url, params);
    },
    GET_CONFIRM_PRIZE ({ dispatch, commit }, { confirmCode }) {
      const url = '/api/community/admin/getConfirmPrize';
      const params = { confirmCode };

      return POST({ dispatch, commit }, url, params);
    },
    CONFIRM ({ dispatch, commit }, { confirmCode }) {
      const url = '/api/community/admin/voucher/confirm';
      const params = { confirmCode };

      return POST({ dispatch, commit }, url, params);
    },
    FIND_DAILY_PRIZE_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/findDailyPrizeList';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    FIND_ACTIVITY_PRIZE_LIST ({ dispatch, commit }, { name }) {
      const url = '/api/community/admin/findActivityPrizeList';
      const params = { name };

      return POST({ dispatch, commit }, url, params);
    },

    /************************************************************************************/

    /*********************
     *  获取获奖用户列表  *
     *********************/
    GET_ACTIVITY_USERS_LIST ({ dispatch, commit }, { index = 1, size = 10, name, phone, type, startTime, endTime, activityId } = {}) {
      const url = '/api/community/admin/getLotteryList';
      const params = { index, size, name, phone, type, startTime, endTime, activityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取用户缴费记录  *
     *********************/
    GET_ACTIVITY_HOUSE_BY_UID ({ dispatch, commit }, { uid, activityId, lotteryId } = {}) {
      const url = '/api/community/admin/getLotteryHousestByUid';
      const params = { uid, activityId, lotteryId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取获奖用户列表  *
     *********************/
    GET_ACTIVITY_USERS_LIST_2 ({ dispatch, commit }, { index = 1, size = 10, name, phone, type, startTime, endTime, activityId } = {}) {
      const url = '/api/community/admin/getLotteryList2';
      const params = { index, size, name, phone, type, startTime, endTime, activityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取获奖用户信息  *
     *********************/
    GET_ACTIVITY_USERS ({ dispatch, commit }, id) {
      const url = '/api/community/admin/getLottery';
      const params = { id };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  抽奖活动-抽奖数据用户统计  *
     *********************/
    GET_LOTTERY_LIST ({ dispatch, commit }, activityId) {
      const url = '/api/community/admin/getActivityLotteryReport';
      const params = { activityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  抽奖活动-邀请来访次数统计  *
     *********************/
    GET_ACTIVITY_INVITE_LIST ({ dispatch, commit }, activityId) {
      const url = '/api/community/admin/getActivityInviteReport';
      const params = { activityId };

      return POST({ dispatch, commit }, url, params);
    },
    /*********************
     *  抽奖活动-邀请来访用户数统计  *
     *********************/
    GET_ACTIVITY_USER_LIST ({ dispatch, commit }, activityId) {
      const url = '/api/community/admin/getActivityUserReport';
      const params = { activityId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    用户反馈                    //

    /*************************************************/

    /*********************
     *  获取用户反馈信息  *
     *********************/
    GET_USERFEEDBACK_LIST ({ dispatch, commit }, { area, communityId, startRow = 1, pageSize = 10, msgTypeGuid } = {}) {
      const url = '/api/community/guanjia/bridgeapi/clientQueryCusTaskList';
      const params = { area, communityId, startRow, pageSize, msgTypeGuid };

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  小富市集-意见反馈详情  *
     *********************/
    GET_USERFEEDBACK_DETAIL ({ dispatch, commit }, { tskCode } = {}) {
      const url = '/api/community/guanjia/bridgeapi/clientGetCusTaskDetail';
      const params = { tskCode };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    参数管理                    //

    /*************************************************/

    /*****************
     *  获取参数列表  *
     *****************/
    GET_WEB_APP_CONF_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getWebAppConfList';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  添加系统参数  *
     *****************/
    CREATE_WEB_APP_CONF ({ dispatch, commit }, { appId, confKey, confValue, confDesc } = {}) {
      const url = '/api/community/admin/addWebAppConf';
      const params = { appId, confKey, confValue, confDesc };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  修改系统参数  *
     *****************/
    EDIT_WEB_APP_CONF ({ dispatch, commit }, { id, appId, confKey, confValue, confDesc } = {}) {
      const url = '/api/community/admin/editWebAppConf';
      const params = { id, appId, confKey, confValue, confDesc };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  删除系统参数  *
     *****************/
    DELETE_WEB_APP_CONF ({ dispatch, commit }, webappConfId) {
      const url = '/api/community/admin/deleteWebAppConf';
      const params = { webappConfId };

      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                      其他                      //

    /*************************************************/

    /***************************
     *  检查 POMP 系统登录权限  *
     ***************************/
    CHECK_POMP_PRIVILEGE ({ dispatch, commit }, params) {
      const url = '/api/community/admin/loginPOMPPrivilegeChecker';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取城市社区列表  *
     *********************/
    GET_CITY_COMMUNITY_LIST ({ dispatch, commit }) {
      const url = '/api/community/admin/getCityCommunityList';
      const params = {};

      return POST({ dispatch, commit }, url, params).then((data) => {
        commit('SET_CITY_COMMUNITY_LIST', data);
        return data;
      });
    },

    /*********************
     *  获取社区分区列表  *
     *********************/
    GET_COMM_AREA_LIST ({ dispatch, commit }, { communityId } = {}) {
      const url = '/api/community/admin/getRoomAreaList';
      const params = { communityId };

      return POST({ dispatch, commit }, url, params).then((data) => {
        return data;
      }, (res) => {
        return Promise.reject(res);
      });
    },

    /*****************
     *  获取楼栋列表--管家  *
     *****************/
    GET_BUILDING_LIST ({ dispatch, commit }, communityIds) {
      const url = '/api/community/admin/getCommunityBuildingList';
      const params = { communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取楼栋列表-- 社区  *
     *****************/
    GET_BUILDING_LIST_ORIG ({ dispatch, commit }, communityIds) {
      const url = '/api/community/admin/getOrigCommunityBuildingList';
      const params = { communityIds };

      return POST({ dispatch, commit }, url, params);
    },

    /**********************************
     *  获取楼栋列表——缴费地址绑定专用  *
     **********************************/
    GET_COMM_BUILDING_LIST ({ dispatch, commit }, { communityId, areaName }) {
      const url = '/api/community/admin/getRoomBuildList';
      const params = { communityId, areaName };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取房间列表  *
     *****************/
    GET_ROOM_LIST ({ dispatch, commit }, { communityId, building }) {
      const url = '/api/community/admin/getCommunityRoomList';
      const params = { communityId, building };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取楼层列表--管家  *
     *****************/
    GET_FLOOR_MATCH_LIST ({ dispatch, commit }, { communityId, building }) {
      const url = '/api/community/admin/getCommunityFloorList';
      const params = { communityId, building };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取楼层列表--社区  *
     *****************/
    GET_FLOOR_MATCH_LIST_ORIG ({ dispatch, commit }, { communityId, building }) {
      const url = '/api/community/admin/getOrigCommunityFloorList';
      const params = { communityId, building };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取单元列表  *
     *****************/
    GET_UNIT_LIST ({ dispatch, commit }, { communityId, areaName, buildName }) {
      const url = '/api/community/admin/getRoomUnitList';
      const params = { communityId, areaName, buildName };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取楼层列表  *
     *****************/
    GET_FLOOR_LIST ({ dispatch, commit }, { communityId, areaName, buildName, unitName }) {
      const url = '/api/community/admin/getRoomFloorList';
      const params = { communityId, areaName, buildName, unitName };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  获取房间号列表  *
     *****************/
    GET_ROOM_NUM_LIST ({ dispatch, commit }, { communityId, areaName, buildName, unitName, floorName }) {
      const url = '/api/community/admin/getRoomNumList';
      const params = { communityId, areaName, buildName, unitName, floorName };

      return POST({ dispatch, commit }, url, params);
    },

    /****************************
     *  根据手机号码获取管家信息  *
     ****************************/
    GET_EMP_INFO ({ dispatch, commit }, phone) {
      const url = '/api/community/admin/getEmpInfo';
      const params = { phone };

      return POST({ dispatch, commit }, url, params);
    },

    /*****************
     *  设置默认社区  *
     *****************/
    SET_DEFAULT_COMM ({ dispatch, commit }, communityIds) {
      const url = '/api/community/admin/setDefCommunityIds';
      const params = { communityIds };

      return POST({ dispatch, commit }, url, params).then(() => {
        return dispatch('REMOVE_ACTIVE_MENU_INDEX');
      });
    },

    /*****************
     *  获取地区列表  *
     ******************/
    GET_AREA_LIST ({ dispatch, commit }, parentId = 100000) {
      const url = '/api/community/admin/getAreaList';
      const params = { parentId };

      return POST({ dispatch, commit }, url, params).then((data) => {
        return data;
      }, (res) => {
        return Promise.reject(res);
      });
    },

    /****************
     *  获取验证码  *
     ****************/
    GET_SMS_CAPTCHA ({ dispatch, commit }) {
      const url = '/api/community/admin/getSmsCaptcha';
      const params = {};

      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取FAQ信息  *
    **********************/
    GET_FAQ_LIST ({ dispatch, commit }, params) {
      const url = '/api/community/getfaqlist';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  添加FAQ信息  *
    **********************/
    ADD_FAQ ({ dispatch, commit }, params) {
      const url = '/api/community/addFaq';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  修改社区服务信息  *
    **********************/
    EDIT_FAQ ({ dispatch, commit }, params) {
      const url = '/api/community/updateFaq';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  删除社区服务信息  *
    **********************/
    DELETE_FAQ ({ dispatch, commit }, params) {
      const url = '/api/community/delFaq';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取操作指引目录树  *
    **********************/
    GET_GUIDE_TREE ({ dispatch, commit }, params) {
      const url = '/api/community/guide/tree';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  获取操作指引内容  *
    **********************/
    GET_GUIDE_CONTENT ({ dispatch, commit }, params) {
      const url = '/api/community/guide/content';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  保存操作指引节点内容  *
    **********************/
    SAVE_GUIDE_CONTENT ({ dispatch, commit }, params) {
      const url = '/api/community/guide/saveContent';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  保存操作指引目录  *
    **********************/
    SAVE_GUIDE_NODE ({ dispatch, commit }, params) {
      const url = '/api/community/guide/saveNode';
      return POST({ dispatch, commit }, url, params);
    },

    /*********************
     *  删除操作指引目录  *
    **********************/
    DELETE_GUIDE_NODE ({ dispatch, commit }, params) {
      const url = '/api/community/guide/deleteNode';
      return POST({ dispatch, commit }, url, params);
    },

    /*************************************************/

    //                    外部方法                    //

    /*************************************************/

    BAIDU_MAP_GET_LOCATION_BY_IP ({ dispatch, commit }) {
      const url = 'https://api.map.baidu.com/location/ip';
      const params = { ak, coor: 'bd09ll' };

      return BAIDU_JSONP({ dispatch, commit }, url, params);
    },

    BAIDU_MAP_GET_LOCATION_BY_ADDRESS ({ dispatch, commit }, address) {
      const url = 'https://api.map.baidu.com/geocoder/v2/';
      const params = { ak, address, output: 'json' };

      return BAIDU_JSONP({ dispatch, commit }, url, params);
    },
  },
  getters: {
    isLogin ({ loginStatus }) {
      return !!loginStatus;
    },
    systemInfo ({ systemInfo }) {
      return systemInfo;
    },
    menuList ({ menuList }) {
      return menuList;
    },
    ifaceList ({ ifaceList }) {
      return ifaceList;
    },

    activeMenuIndex ({ activeMenuIndex }) {
      return activeMenuIndex;
    },
    activeItemIndex ({ activeItemIndex }) {
      return activeItemIndex;
    },

    unreadSysMsgCount ({ unreadSysMsgCount }) {
      return unreadSysMsgCount;
    },
    unreadMsgInfoCount ({ unreadMsgInfoCount }) {
      return unreadMsgInfoCount;
    },
    unreadSysNoticeCount ({ unreadSysNoticeCount }) {
      return unreadSysNoticeCount;
    },

    isDeptSelectorShown ({ deptSelectorShow }) {
      return deptSelectorShow;
    },
    selectedDept ({ selectedDept }) {
      return selectedDept;
    },

    isAreaSelectorShown ({ areaSelectorShow }) {
      return areaSelectorShow;
    },
    selectedArea ({ selectedArea }) {
      return selectedArea;
    },

    isRoleSelectorShown ({ roleSelectorShow }) {
      return roleSelectorShow;
    },
    selectedRole ({ selectedRole }) {
      return selectedRole;
    },

    adCategoryList ({ adCategoryList }) {
      return adCategoryList;
    },
    addAdCategoryList ({ addAdCategoryList }) {
      return addAdCategoryList;
    },
    editAdCategoryList ({ editAdCategoryList }) {
      return editAdCategoryList;
    },
    sysResourceList ({ sysResourceList }) {
      return sysResourceList;
    },

    repairProblemTypeList ({ repairProblemTypeList }) {
      return repairProblemTypeList;
    },

    venueServiceTypeList ({ venueServiceTypeList }) {
      return venueServiceTypeList;
    },
    enabledVenueList ({ enabledVenueList }) {
      return enabledVenueList;
    },

    parkingConfList ({ parkingConfList }) {
      return parkingConfList;
    },

    cityCommunityList_match ({ cityCommunityList_match }) {
      // 获取数据匹配城市列表
      let ccL = [];
      cityCommunityList_match.forEach((city) => {
        let commList = [];
        if (Array.isArray(city.communityList) && city.communityList.length > 0) {
          city.communityList.forEach((community) => {
            commList.push(Object.assign({}, community, {
              cityId: city.cityId,
              cityName: city.cityName,
              fullName: city.cityName + ' - ' + community.communityName,
            }));
          });

          ccL.push(Object.assign({}, city, {
            communityList: commList.slice()
          }));
        }
      });
      return ccL;
    },
    allCommunityList_match ({ cityCommunityList_match }) {
      let l = [];
      if (cityCommunityList_match.length > 0) {
        cityCommunityList_match.forEach((city) => {
          if (Array.isArray(city.communityList) && city.communityList.length > 0) {
            city.communityList.forEach((community) => {
              l.push(Object.assign({}, community, {
                cityId: city.cityId,
                cityName: city.cityName,
                fullName: city.cityName + ' - ' + community.communityName,
              }));
            });
          }
        });
      }
      return l;
    },

    cityCommunityList ({ cityCommunityList }) {
      let ccL = [];
      cityCommunityList.forEach((city) => {
        let commList = [];
        if (Array.isArray(city.communityList) && city.communityList.length > 0) {
          city.communityList.forEach((community) => {
            commList.push(Object.assign({}, community, {
              cityId: city.cityId,
              cityName: city.cityName,
              fullName: city.cityName + ' - ' + community.communityName,
            }));
          });

          ccL.push(Object.assign({}, city, {
            communityList: commList.slice()
          }));
        }
      });
      return ccL;
    },
    allCommunityList ({ cityCommunityList }) {
      let l = [];
      if (cityCommunityList.length > 0) {
        cityCommunityList.forEach((city) => {
          if (Array.isArray(city.communityList) && city.communityList.length > 0) {
            city.communityList.forEach((community) => {
              l.push(Object.assign({}, community, {
                cityId: city.cityId,
                cityName: city.cityName,
                fullName: city.cityName + ' - ' + community.communityName,
              }));
            });
          }
        });
      }
      return l;
    },

    themeCommTagList ({ themeCommTagList }) {
      return themeCommTagList;
    },
    themeCommList ({ virtualCityCommunityList }) {
      let l = [];
      virtualCityCommunityList.forEach((city) => {
        if (Array.isArray(city.communityList) && city.communityList.length > 0) {
          city.communityList.forEach((community) => {
            l.push(Object.assign({}, community, {
              cityId: city.tagId,
              cityName: city.tagName,
              fullName: city.tagName + ' - ' + community.communityName,
            }));
          });
        }
      });
      return l;
    },

    virtualCityCommunityList ({ virtualCityCommunityList }) {
      let ccL = [];
      virtualCityCommunityList.forEach((city) => {
        let commList = [];
        if (Array.isArray(city.communityList) && city.communityList.length > 0) {
          city.communityList.forEach((community) => {
            commList.push(Object.assign({}, community, {
              cityId: city.tagId,
              cityName: city.tagName,
              fullName: city.tagName + ' - ' + community.communityName,
            }));
          });
          ccL.push(Object.assign({}, city, {
            cityId: city.tagId,
            cityName: city.tagName,
            communityList: commList.slice()
          }));
        }
      });
      return ccL;
    },

    allVirtualCommunityList ({ virtualCityCommunityList }) {
      if (virtualCityCommunityList.length > 0) {
        let l = [];
        virtualCityCommunityList.forEach((city) => {
          if (Array.isArray(city.communityList) && city.communityList.length > 0) {
            city.communityList.forEach((community) => {
              l.push(Object.assign({}, community, {
                cityId: city.cityId,
                cityName: city.cityName,
                fullName: city.tagId + ' - ' + community.communityName,
              }));
            });
          }
        });
        return l;
      } else {
        return [];
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/vuex/index.js